var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "456",
        height: "24",
        viewBox: "0 0 456 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_778_1196)" } }, [
        _c("path", {
          attrs: {
            d:
              "M2.5595 12.1652L0.111084 8.18164H1.33926L3.04759 10.9633L4.75394 8.18164H5.98212L3.5337 12.1652H2.55751H2.5595Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M6.33728 12.1652V8.18164H10.8135V9.03738H7.42855V9.71607H9.77974L9.47815 10.5718H7.43053V11.3095H10.9702V12.1652H6.33728Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M15.5635 12.1652L12.8988 9.4682V12.1672H11.8055V8.18164H13.0258L15.6944 10.8925V8.18164H16.7877V12.1652H15.5635Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M20.7916 11.3095C20.9901 11.3095 21.1865 11.2682 21.367 11.1856C21.5476 11.103 21.7083 10.983 21.8373 10.8334C21.9861 10.6564 22.0714 10.4321 22.0754 10.2C22.0754 10.0367 22.0397 9.87738 21.9742 9.72787C21.9067 9.58033 21.8115 9.44656 21.6905 9.33639C21.5694 9.22623 21.4266 9.14361 21.2718 9.09246C21.117 9.04131 20.9524 9.02164 20.7897 9.03738H19.0635V11.3075H20.7956L20.7916 11.3095ZM17.9662 12.1652V8.18164H20.7242C22.2381 8.18164 23.2162 8.98033 23.2162 10.2157C23.2202 10.4971 23.1528 10.7764 23.0238 11.0282C22.8948 11.28 22.7063 11.4964 22.4762 11.6597C22.0059 11.998 21.4385 12.1751 20.8571 12.1633H17.9662V12.1652Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M25.7699 8.38427L26.246 7.27673H27.1945L26.3333 8.38427H25.7679H25.7699ZM24.1945 12.1653V8.18165H28.6706V9.03739H25.2857V9.71608H27.6369L27.3353 10.5718H25.2857V11.3095H28.8274V12.1653H24.1945Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M29.6627 12.1652V8.18164H34.1389V9.03738H30.754V9.71607H33.1051L32.8036 10.5718H30.754V11.3095H34.2936V12.1652H29.6607H29.6627Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M13.1568 20.0105V19.1154H13.3532V19.8374H13.9762V20.0085H13.1548L13.1568 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M14.125 20.0105V19.1154H15.0039V19.2866H14.3214V19.4695H14.7956V19.6407H14.3214V19.8374H15.0337V20.0085H14.123L14.125 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M15.623 19.2689C15.4544 19.2689 15.3671 19.3023 15.3671 19.3633C15.3671 19.3948 15.3909 19.4144 15.4365 19.4282C15.5377 19.444 15.6409 19.4518 15.744 19.4558C15.998 19.4813 16.121 19.5502 16.121 19.7253C16.121 19.9181 15.9544 20.0341 15.6468 20.0341C15.4563 20.04 15.2718 19.981 15.121 19.8669L15.2282 19.7213C15.3532 19.8099 15.502 19.859 15.6548 19.859C15.8175 19.859 15.9107 19.8079 15.9107 19.7351C15.9107 19.6564 15.8075 19.6564 15.6329 19.6485C15.3175 19.6328 15.1607 19.5659 15.1607 19.3849C15.1607 19.204 15.3194 19.0997 15.6131 19.0997C15.7817 19.0918 15.9484 19.1371 16.0893 19.2295L15.9762 19.3731C15.869 19.3082 15.746 19.2728 15.621 19.2728",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M17.1032 19.2689C16.9345 19.2689 16.8472 19.3023 16.8472 19.3633C16.8472 19.3948 16.871 19.4144 16.9167 19.4282C17.0179 19.444 17.121 19.4518 17.2242 19.4558C17.4782 19.4813 17.6012 19.5502 17.6012 19.7253C17.6012 19.9181 17.4345 20.0341 17.127 20.0341C16.9365 20.04 16.752 19.981 16.6012 19.8669L16.7083 19.7213C16.8333 19.8099 16.9821 19.859 17.1369 19.859C17.2996 19.859 17.3929 19.8079 17.3929 19.7351C17.3929 19.6564 17.2897 19.6564 17.1151 19.6485C16.7996 19.6328 16.6429 19.5659 16.6429 19.3849C16.6429 19.204 16.8016 19.0997 17.0952 19.0997C17.2639 19.0918 17.4306 19.1371 17.5714 19.2295L17.4603 19.3731C17.3532 19.3082 17.2302 19.2728 17.1052 19.2728",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M18.2063 19.2807L18.0278 19.6466H18.3849L18.2063 19.2807ZM18.5595 20.0105L18.4663 19.8177H17.9484L17.8552 20.0105H17.6567L18.0873 19.1154H18.3294L18.7599 20.0105H18.5595Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M19.6925 19.741C19.6925 19.7253 19.6905 19.7115 19.6845 19.6977C19.6786 19.684 19.6687 19.6722 19.6587 19.6623C19.6468 19.6525 19.6349 19.6446 19.619 19.6407C19.6052 19.6367 19.5893 19.6348 19.5754 19.6367H19.0794V19.8394H19.5734C19.6528 19.8394 19.6944 19.8059 19.6944 19.743M19.6528 19.3751C19.6528 19.3633 19.6528 19.3515 19.6468 19.3417C19.6429 19.3318 19.6369 19.322 19.627 19.3122C19.619 19.3043 19.6091 19.2984 19.5972 19.2944C19.5853 19.2905 19.5754 19.2885 19.5635 19.2885H19.0774V19.4656H19.5714C19.5833 19.4656 19.5933 19.4617 19.6032 19.4577C19.6131 19.4538 19.623 19.4459 19.631 19.4381C19.6389 19.4302 19.6448 19.4203 19.6488 19.4085C19.6528 19.3987 19.6548 19.3869 19.6528 19.3751ZM19.8948 19.7528C19.8948 19.9003 19.7778 20.0085 19.5873 20.0085H18.879V19.1135H19.5635C19.6071 19.1135 19.6508 19.1233 19.6905 19.141C19.7302 19.1587 19.7659 19.1862 19.7936 19.2197C19.8294 19.263 19.8492 19.3161 19.8472 19.3712C19.8472 19.4046 19.8433 19.4381 19.8274 19.4676C19.8135 19.4971 19.7917 19.5226 19.7639 19.5423C19.8016 19.562 19.8333 19.5915 19.8552 19.6289C19.877 19.6643 19.8889 19.7076 19.8889 19.7489",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M20.1052 20.0105V19.1154H20.3016V19.8374H20.9246V20.0085H20.1052V20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M21.0714 20.0105V19.1154H21.9504V19.2866H21.2679V19.4695H21.7421V19.6407H21.2679V19.8374H21.9802V20.0085H21.0695L21.0714 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M22.5714 19.2689C22.4028 19.2689 22.3155 19.3023 22.3155 19.3633C22.3155 19.3948 22.3393 19.4144 22.3849 19.4282C22.4861 19.444 22.5893 19.4518 22.6925 19.4558C22.9464 19.4813 23.0675 19.5502 23.0675 19.7253C23.0675 19.9181 22.9028 20.0341 22.5953 20.0341C22.4048 20.04 22.2203 19.981 22.0695 19.8669L22.1766 19.7213C22.3016 19.8099 22.4504 19.859 22.6052 19.859C22.7679 19.859 22.8611 19.8079 22.8611 19.7351C22.8611 19.6564 22.758 19.6564 22.5833 19.6485C22.2679 19.6328 22.1111 19.5659 22.1111 19.3849C22.1111 19.204 22.2699 19.0997 22.5635 19.0997C22.7322 19.0918 22.8988 19.1371 23.0397 19.2295L22.9286 19.3731C22.8214 19.3082 22.6984 19.2728 22.5734 19.2728",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M24.3908 19.7233C24.4226 19.678 24.4404 19.6249 24.4404 19.5698C24.4424 19.5325 24.4365 19.4971 24.4246 19.4617C24.4127 19.4282 24.3928 19.3967 24.367 19.3692C24.3412 19.3436 24.3115 19.322 24.2778 19.3082C24.244 19.2944 24.2063 19.2866 24.1706 19.2885H23.8095V19.8394H24.1686C24.2123 19.8394 24.2539 19.8276 24.2916 19.8079C24.3293 19.7882 24.3631 19.7587 24.3869 19.7253M24.6448 19.5758C24.6448 19.6367 24.6349 19.6977 24.6091 19.7528C24.5833 19.8079 24.5476 19.859 24.5 19.8984C24.4107 19.9731 24.2976 20.0125 24.1805 20.0125H23.6111V19.1174H24.1547C24.2182 19.1115 24.2817 19.1174 24.3432 19.139C24.4047 19.1587 24.4603 19.1921 24.5059 19.2354C24.5535 19.2787 24.5893 19.3318 24.6131 19.3908C24.6369 19.4498 24.6488 19.5128 24.6468 19.5758",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M24.8036 19.4754H24.756V19.3731H24.7679C24.8214 19.3731 24.8472 19.3613 24.8472 19.3279V19.2885H24.75V19.1174H24.9583V19.3259C24.9583 19.3456 24.9583 19.3672 24.9504 19.3869C24.9425 19.4066 24.9325 19.4243 24.9167 19.438C24.9028 19.4518 24.8849 19.4636 24.8651 19.4695C24.8452 19.4754 24.8254 19.4774 24.8036 19.4754Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M25.6667 19.263C25.6091 19.2708 25.5536 19.2964 25.5099 19.3338C25.4663 19.3712 25.4325 19.4223 25.4167 19.4774C25.4008 19.5325 25.4008 19.5934 25.4167 19.6485C25.4325 19.7036 25.4663 19.7548 25.5099 19.7921C25.5536 19.8295 25.6091 19.8551 25.6667 19.863C25.7242 19.8708 25.7837 19.863 25.8373 19.8394C25.8909 19.8157 25.9365 19.7764 25.9683 19.7272C26 19.678 26.0159 19.621 26.0159 19.562C26.0159 19.5187 26.006 19.4754 25.9861 19.438C25.9683 19.3987 25.9405 19.3633 25.9087 19.3357C25.875 19.3082 25.8373 19.2866 25.7956 19.2748C25.754 19.263 25.7103 19.259 25.6667 19.2649V19.263ZM26.0774 19.8905C25.9623 19.9849 25.8155 20.038 25.6667 20.038C25.5179 20.038 25.371 19.9869 25.256 19.8905C25.2123 19.8492 25.1766 19.798 25.1528 19.741C25.129 19.6839 25.1171 19.6249 25.1171 19.5639C25.1171 19.503 25.129 19.4439 25.1528 19.3869C25.1766 19.3318 25.2123 19.2807 25.256 19.2374C25.371 19.143 25.5159 19.0898 25.6667 19.0898C25.8175 19.0898 25.9623 19.143 26.0774 19.2374C26.121 19.2787 26.1567 19.3298 26.1806 19.3869C26.2044 19.442 26.2163 19.503 26.2163 19.5639C26.2163 19.6249 26.2044 19.6859 26.1806 19.741C26.1567 19.7961 26.121 19.8472 26.0774 19.8905Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M26.4345 20.0105V19.1154H26.631V19.8374H27.254V20.0085H26.4326L26.4345 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M27.8631 19.263C27.8214 19.2571 27.7758 19.263 27.7361 19.2748C27.6944 19.2866 27.6567 19.3082 27.623 19.3377C27.5893 19.3653 27.5635 19.4007 27.5456 19.44C27.5278 19.4794 27.5178 19.5207 27.5159 19.5639C27.5059 19.6348 27.5159 19.7056 27.5496 19.7705C27.5813 19.8335 27.6329 19.8866 27.6964 19.92C27.7599 19.9535 27.8313 19.9672 27.9028 19.9594C27.9742 19.9515 28.0417 19.922 28.0952 19.8748C28.1488 19.8275 28.1885 19.7666 28.2043 19.6977C28.2222 19.6289 28.2182 19.5561 28.1924 19.4892C28.1666 19.4223 28.123 19.3653 28.0635 19.3259C28.004 19.2846 27.9345 19.2649 27.8631 19.2649V19.263ZM28.2738 19.8905C28.1587 19.9849 28.0119 20.038 27.8631 20.038C27.7143 20.038 27.5674 19.9869 27.4524 19.8905C27.4087 19.8492 27.373 19.798 27.3492 19.741C27.3254 19.6859 27.3135 19.6249 27.3135 19.5639C27.3135 19.503 27.3254 19.4439 27.3492 19.3869C27.373 19.3318 27.4087 19.2807 27.4524 19.2374C27.5674 19.143 27.7123 19.0898 27.8631 19.0898C28.0139 19.0898 28.1587 19.143 28.2738 19.2374C28.3174 19.2787 28.3532 19.3298 28.377 19.3869C28.4008 19.442 28.4127 19.503 28.4127 19.5639C28.4127 19.6249 28.4008 19.6859 28.377 19.741C28.3532 19.7961 28.3174 19.8472 28.2738 19.8905Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M29.3829 20.0105L28.8333 19.3731H28.8294V20.0105H28.6329V19.1154H28.8631L29.4127 19.7548H29.4187V19.1174H29.6151V20.0125H29.3849L29.3829 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M30.623 20.0105L30.0734 19.3731H30.0694V20.0105H29.873V19.1154H30.1012L30.6508 19.7548H30.6547V19.1174H30.8512V20.0125H30.619L30.623 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M31.1131 20.0105V19.1154H31.992V19.2866H31.3095V19.4695H31.7837V19.6407H31.3095V19.8374H32.0218V20.0085H31.1111L31.1131 20.0105Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M14.7738 17.6951C14.1289 17.7088 13.496 17.522 12.9603 17.1639C12.7024 16.9849 12.492 16.7488 12.3472 16.4715C12.2024 16.1941 12.127 15.8872 12.1289 15.5764C12.1289 15.2656 12.2083 14.9587 12.3551 14.6833C12.502 14.4079 12.7143 14.1718 12.9722 13.9947C13.5178 13.6229 14.1686 13.4341 14.8293 13.4577C15.25 13.442 15.6666 13.5187 16.0535 13.6859C16.4385 13.8511 16.7817 14.101 17.0575 14.4157L17.1131 14.4787L16.373 14.8347L16.3412 14.8013C16.1389 14.5928 15.8948 14.4295 15.625 14.3213C15.3551 14.2131 15.0655 14.162 14.7738 14.1738C14.3313 14.1659 13.8968 14.2879 13.5258 14.5279C13.3492 14.642 13.2043 14.7974 13.1031 14.9803C13.002 15.1633 12.9504 15.3698 12.9524 15.5784C12.9524 16.4184 13.6845 16.9829 14.7758 16.9829C15.5694 16.9829 16.1488 16.6741 16.4147 16.1075H14.5714V15.3993H17.4087V15.5213C17.4087 16.8236 16.3492 17.699 14.7738 17.699V17.6951Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M18.4186 17.583V13.5817H19.2143V16.8728H22.3551L22.0714 17.583H18.4206H18.4186Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M25.0992 14.1738C24.0198 14.1738 23.2659 14.7522 23.2659 15.5784C23.2659 16.4046 23.9861 16.983 25.0992 16.983C26.2123 16.983 26.9226 16.4184 26.9226 15.5784C26.9226 15.3699 26.871 15.1633 26.7718 14.9804C26.6706 14.7974 26.5258 14.64 26.3492 14.5279C25.9782 14.2879 25.5436 14.164 25.1012 14.1758M25.1012 17.699C24.4544 17.7128 23.8175 17.5279 23.2817 17.1679C23.0218 16.9908 22.8095 16.7548 22.6647 16.4774C22.5178 16.2 22.4425 15.8931 22.4444 15.5804C22.4444 15.2676 22.5238 14.9607 22.6706 14.6853C22.8194 14.4099 23.0317 14.1738 23.2936 13.9987C23.8294 13.6486 24.4563 13.4617 25.0992 13.4617C25.7421 13.4617 26.369 13.6486 26.9048 13.9987C27.1647 14.1758 27.377 14.4118 27.5238 14.6872C27.6706 14.9627 27.748 15.2715 27.748 15.5843C27.748 15.8971 27.6726 16.204 27.5258 16.4813C27.379 16.7587 27.1686 16.9948 26.9087 17.1718C26.377 17.5299 25.744 17.7128 25.1012 17.6971",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M34.3571 17.583V13.5817H38.5456V14.2918H35.1528V15.1554H37.5416L37.2599 15.8656H35.1547V16.8748H38.7043V17.5849H34.3591L34.3571 17.583Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M29.5496 15.5823L29.9504 15.2046H31.8056C31.9444 15.2204 32.0853 15.181 32.1964 15.0945C32.3075 15.0079 32.379 14.882 32.3948 14.7423C32.3948 14.4649 32.1806 14.2918 31.8353 14.2918H29.5516V15.5823H29.5496ZM31.754 16.8728C32.4325 16.8728 32.5238 16.6387 32.5238 16.4125C32.5238 16.0682 32.3194 15.9128 31.8591 15.9128H29.5496V16.8728H31.754ZM28.754 17.583V13.5817H31.7937C32.6429 13.5817 33.1706 14.0125 33.1706 14.7049C33.1766 14.8663 33.1369 15.0256 33.0595 15.1672C32.9821 15.3089 32.8671 15.4269 32.7282 15.5095C32.9206 15.5922 33.0833 15.7318 33.1925 15.9089C33.3016 16.0859 33.3532 16.2945 33.3373 16.501C33.3373 16.9928 33.0595 17.581 31.75 17.581H28.754V17.583Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M23.4286 0.928519C22.0079 2.21114 22.0813 4.44393 22.8353 6.70229C24.2639 3.99147 29.4107 2.38622 29.4107 2.38622C28.0635 1.48721 26.5972 0.775077 25.0536 0.273438C24.4623 0.340323 23.8988 0.566552 23.4286 0.930487V0.928519Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M47.5496 6.69048C42.9008 2.80524 32.1091 0.114092 27.0635 0.129829C29.9444 0.857698 33.5297 3.18294 36.877 6.75934C42.246 12.4977 45.123 19.4498 43.7936 23.0479C46.5536 20.7915 53.496 11.6577 47.5516 6.69048",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M45.1468 10.5128C45.1607 10.4813 45.1925 10.4616 45.2064 10.4282C45.2639 10.3751 45.3095 10.2905 45.4048 10.2905C45.4901 10.2649 45.5794 10.2531 45.6707 10.257C45.7937 10.2472 45.9167 10.257 46.0298 10.257C46.0794 10.2551 46.129 10.257 46.1786 10.261C46.1984 10.2452 46.2203 10.2728 46.2421 10.2551C46.4861 10.2472 46.7322 10.259 46.9762 10.2885C47.004 10.2865 47.0298 10.2885 47.0615 10.2885C47.1687 10.3062 47.2778 10.3121 47.3869 10.3082C47.4841 10.3042 47.5992 10.2944 47.6984 10.2806C47.7103 10.2924 47.7203 10.2767 47.7322 10.2767C47.7798 10.2806 47.8274 10.2708 47.8711 10.2472C47.8711 10.259 47.883 10.2472 47.8849 10.2551C47.8691 10.2767 47.8711 10.3082 47.8373 10.3141L47.758 10.4105C47.7183 10.4459 47.6826 10.4852 47.6488 10.5265C47.5853 10.6072 47.5377 10.7056 47.4365 10.737C47.3651 10.7449 47.2937 10.7606 47.2242 10.7842C47.2044 10.7803 47.2024 10.8019 47.1826 10.7941C47.1667 10.8078 47.1409 10.8 47.125 10.8098C47.0298 10.8374 46.9326 10.857 46.8334 10.8669C46.4623 10.8728 46.1191 10.8275 45.7322 10.8551C45.5675 10.8629 45.3849 10.8629 45.2262 10.8551C45.1865 10.8393 45.1429 10.8492 45.1171 10.8078C45.1092 10.7823 45.0893 10.7646 45.0953 10.7351C45.0814 10.7075 45.0953 10.676 45.0913 10.6465C45.0992 10.5954 45.1191 10.5482 45.1528 10.5088",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M44.6607 11.6754C44.5576 11.9646 44.5655 12.2813 44.6885 12.5646C44.7084 12.6059 44.7242 12.6472 44.7361 12.6905C44.758 12.72 44.7738 12.7515 44.7877 12.7849C44.8214 12.8538 44.8631 12.9226 44.8968 12.9935C45.1726 13.4636 45.5159 13.8925 45.9167 14.2643C45.9306 14.28 45.9464 14.2918 45.9623 14.3036C46.0734 14.4099 46.1925 14.5063 46.3195 14.5889C46.3334 14.5948 46.3413 14.6144 46.3611 14.6125C46.4742 14.5279 46.5714 14.4276 46.6528 14.3135C46.7222 14.2348 46.7818 14.1482 46.8532 14.0735C46.9584 13.9417 47.0576 13.8059 47.1488 13.6643C47.1726 13.623 47.2004 13.5856 47.2203 13.5443C47.254 13.5049 47.2619 13.4459 47.2976 13.4105C47.2917 13.3948 47.3056 13.3869 47.3115 13.379C47.3433 13.3043 47.373 13.2236 47.3968 13.1489C47.4207 13.0958 47.4385 13.0407 47.4484 12.9817C47.4584 12.9207 47.4782 12.8676 47.4881 12.8105C47.5 12.7003 47.502 12.5902 47.4941 12.482C47.496 12.4446 47.4901 12.4053 47.4782 12.3699C47.4643 12.3541 47.4822 12.3364 47.4663 12.3226C47.4464 12.2282 47.4167 12.1377 47.373 12.0512C47.2976 11.8938 47.1945 11.7482 47.0714 11.6223L47.0337 11.5908C47.0337 11.6184 47.0933 11.6853 47.0893 11.7167C47.1548 11.8781 47.1687 12.0531 47.129 12.2223C47.0278 12.6571 46.7857 13.0446 46.4405 13.3299C46.3512 13.3987 46.2718 13.4872 46.1786 13.5502C46.1647 13.5679 46.1449 13.5817 46.125 13.5915C46.0913 13.6249 46.0536 13.6544 46.0159 13.682C45.9722 13.7115 45.9246 13.7351 45.877 13.7567C45.8512 13.7567 45.8334 13.7312 45.8155 13.7154C45.8195 13.7056 45.8274 13.7095 45.8373 13.7036C45.9246 13.621 46.0476 13.56 46.1091 13.4459C46.125 13.4322 46.1369 13.4144 46.1468 13.3967C46.2262 13.2944 46.2897 13.1823 46.3373 13.0623C46.3651 13.0112 46.379 12.96 46.4087 12.9089C46.4365 12.8577 46.4385 12.7928 46.4623 12.7377C46.4703 12.6885 46.4841 12.6354 46.496 12.5922C46.4921 12.5469 46.5199 12.5076 46.5199 12.4584C46.5218 12.3167 46.4941 12.1771 46.4365 12.0472C46.379 11.9174 46.2937 11.8013 46.1865 11.7089C46.0933 11.6046 45.9762 11.522 45.8453 11.4708C45.8453 11.4669 45.8115 11.461 45.8195 11.4649L45.8254 11.4728C45.881 11.5535 45.9266 11.6381 45.9643 11.7285C45.9961 11.8171 45.9306 11.8879 45.9207 11.9725C45.9008 12.0079 45.873 12.0394 45.8393 12.063C45.8274 12.063 45.8175 12.0866 45.8036 12.0728C45.7857 12.0984 45.7659 12.12 45.7401 12.1377C45.7024 12.1358 45.6925 12.1889 45.6607 12.1987C45.6052 12.1987 45.6032 12.2695 45.5476 12.2715C45.5258 12.3364 45.4484 12.3325 45.4207 12.3895C45.4008 12.3974 45.377 12.3994 45.3611 12.419C45.3572 12.423 45.3433 12.4289 45.3413 12.4151C45.3631 12.3384 45.373 12.2577 45.3711 12.1771C45.3334 12.0472 45.2679 11.9253 45.1806 11.821C45.1131 11.7344 45.0278 11.6636 44.9286 11.6144C44.8671 11.5712 44.7957 11.5456 44.7203 11.5417C44.7064 11.579 44.6746 11.6105 44.6726 11.6518C44.6647 11.6617 44.6587 11.6735 44.6568 11.6853M43.123 12.1023C43.1587 12.002 43.2103 11.9095 43.2718 11.823C43.3135 11.7738 43.3591 11.7285 43.4107 11.6912C43.4961 11.6085 43.6052 11.5554 43.6945 11.4846C43.7341 11.4551 43.7897 11.4433 43.7976 11.3862C43.7877 11.1403 43.6925 10.8964 43.7024 10.6505C43.7024 10.5659 43.7282 10.4735 43.7282 10.3967C43.7957 10.2689 43.8711 10.1469 43.9564 10.0308C44.002 9.94625 44.0576 9.86756 44.1191 9.79478C44.1845 9.73969 44.2599 9.69838 44.3413 9.67281C44.373 9.65904 44.4048 9.64723 44.4365 9.63937C44.6369 9.58822 44.8413 9.55478 45.0457 9.53707C45.133 9.53117 45.2183 9.51543 45.3036 9.5115C45.3195 9.5115 45.3373 9.50756 45.3532 9.50166C45.3294 9.33641 45.3135 9.1692 45.3076 9.00199C45.1508 8.99609 44.9921 9.00199 44.8353 9.01772C44.8294 9.01772 44.8234 9.01182 44.8195 9.00789C44.8155 9.00199 44.8135 8.99609 44.8135 8.99018C44.8611 8.82691 45.004 8.70887 45.0675 8.55543C45.1111 8.50428 45.127 8.4433 45.1707 8.39215C45.2361 8.39215 45.3016 8.38625 45.3651 8.37051C45.3869 8.341 45.3869 8.30166 45.4107 8.27412C45.4643 8.24264 45.5119 8.1974 45.5675 8.16789C45.6171 8.12658 45.6766 8.10494 45.7262 8.06559C45.7758 8.04002 45.8214 8.01051 45.8671 7.97707C45.9048 7.95543 45.9385 7.92789 45.9802 7.90625L45.9961 7.92199C45.9425 8.05969 45.9147 8.20723 45.9127 8.35478L45.9226 8.36658C46.0457 8.37248 46.1667 8.36264 46.2877 8.341C46.3214 8.34887 46.3611 8.32133 46.3988 8.32723C46.502 8.29576 46.629 8.29379 46.7302 8.25445C46.7381 8.24264 46.752 8.23674 46.7639 8.23477C46.7639 8.27609 46.7203 8.30756 46.7024 8.34297C46.6865 8.38035 46.6647 8.41379 46.6369 8.4433C46.625 8.48855 46.5794 8.51805 46.5734 8.56527C46.5476 8.61248 46.5179 8.65969 46.4861 8.70297C46.4603 8.75019 46.4524 8.81904 46.3929 8.84658C46.379 8.85445 46.3591 8.85248 46.3492 8.86822C46.2103 8.88986 46.0933 8.95281 45.9544 8.97051L45.9345 8.97641C45.9524 9.12395 45.9425 9.27543 45.9068 9.41904C45.879 9.42887 45.8552 9.44264 45.8353 9.46428C45.8115 9.47412 45.7897 9.48986 45.7718 9.50756C45.9028 9.52527 46.0318 9.52133 46.1647 9.5351C46.3572 9.541 46.5417 9.55477 46.7341 9.55281L46.7401 9.55674C46.756 9.55674 46.7699 9.55478 46.7857 9.55084C46.9068 9.55674 47.0278 9.55084 47.1488 9.5351C47.2401 9.52723 47.3314 9.5115 47.4187 9.48986C47.4464 9.47609 47.4921 9.48986 47.5139 9.46035C47.5357 9.43871 47.5298 9.47018 47.5218 9.48592C47.4703 9.55478 47.4147 9.62166 47.3532 9.68264C47.3393 9.72592 47.2897 9.7515 47.2699 9.79871C47.2163 9.85576 47.1746 9.901 47.1171 9.96199C47.0834 9.96396 47.0615 9.99543 47.0258 9.9915C46.8949 10.0348 46.7599 10.0682 46.623 10.0938C46.6131 10.0977 46.5972 10.0918 46.5933 10.1036C46.5516 10.1036 46.5099 10.1115 46.4722 10.1154C46.3334 10.1056 46.2004 10.139 46.0655 10.1174C45.8016 10.1292 45.5457 10.0781 45.2838 10.0899C45.0853 10.0899 44.8869 10.1036 44.6925 10.1331C44.5853 10.1371 44.4802 10.1508 44.375 10.1744C44.3076 10.2374 44.3294 10.381 44.3314 10.4676C44.3611 10.6505 44.3988 10.8551 44.4286 11.04C44.3453 11.2151 44.1488 11.2603 44.0099 11.3843C43.9147 11.4551 43.8353 11.5456 43.7778 11.6499C43.7203 11.7541 43.6845 11.8682 43.6746 11.9863C43.6369 12.3699 43.7322 12.7535 43.9445 13.0761C44.0417 13.2512 44.1488 13.4203 44.2679 13.5817C44.4564 13.8531 44.6726 14.1069 44.9087 14.339L44.9226 14.284C44.8393 14.1777 44.7302 14.0636 44.6528 13.9554C44.508 13.7646 44.379 13.5659 44.2619 13.3574C44.2401 13.3397 44.248 13.3023 44.2183 13.2846C44.2064 13.2394 44.1746 13.2079 44.1607 13.1626C44.1369 13.1095 44.1131 13.0544 44.0933 12.9974C44.0714 12.9541 44.0556 12.9108 44.0457 12.8636C44.0199 12.7889 44.002 12.7102 43.9901 12.6315C43.9782 12.5922 43.9742 12.5508 43.9742 12.5095C43.9742 12.3226 44.008 12.1377 44.0774 11.9626C44.1191 11.8781 44.1687 11.8013 44.2302 11.7285C44.2659 11.699 44.2837 11.6538 44.3274 11.6322C44.3671 11.583 44.4147 11.5436 44.4683 11.5141L44.4802 11.4964C44.623 11.4138 44.752 11.3095 44.8968 11.2249C44.9286 11.2013 44.9623 11.1817 44.998 11.162C45.0318 11.1285 45.0814 11.1089 45.1191 11.0774C45.125 11.0774 45.133 11.0774 45.133 11.0695C45.1945 11.0558 45.258 11.0558 45.3195 11.0695C45.381 11.0833 45.4385 11.1108 45.4881 11.1502C45.6072 11.219 45.7084 11.3135 45.7857 11.4276C45.8314 11.4059 45.8552 11.3666 45.8929 11.341C46.008 11.2426 46.0992 11.1502 46.2183 11.0558C46.2401 11.0361 46.2599 11.0164 46.2798 10.9928C46.3393 10.9849 46.3968 10.9987 46.4464 11.0322C46.5992 11.1187 46.7361 11.2269 46.8552 11.3548C46.875 11.3508 46.8929 11.341 46.9048 11.3253C46.9861 11.2682 47.0695 11.2013 47.1468 11.1384C47.1786 11.1207 47.1964 11.0912 47.2302 11.0754C47.2738 11.0341 47.3214 10.9987 47.371 10.9672L47.3988 10.9515C47.6726 11.2033 47.8949 11.5082 48.0476 11.8466C48.0476 11.8544 48.0476 11.8603 48.0476 11.8682C48.0476 11.8761 48.0536 11.882 48.0576 11.8859C48.125 12.0925 48.1349 12.3148 48.0834 12.5272C48.0099 12.8754 47.8591 13.2 47.6389 13.4794C47.5536 13.5994 47.4484 13.7154 47.3591 13.8354L47.3492 13.8394C47.2679 13.9377 47.1826 14.0223 47.0992 14.1148C47.0794 14.1246 47.0655 14.1522 47.0496 14.1659C46.9524 14.2446 46.881 14.3292 46.7818 14.4059C46.6945 14.4748 46.6131 14.5436 46.5218 14.6066C46.498 14.6302 46.4703 14.6518 46.4425 14.6735C46.4524 14.6951 46.4802 14.703 46.502 14.7128C46.5139 14.7148 46.5258 14.7207 46.5357 14.7305C46.5437 14.7403 46.5516 14.7502 46.5536 14.764C46.5496 14.7954 46.5199 14.7994 46.506 14.8289C46.506 14.8367 46.502 14.8446 46.498 14.8525C46.4941 14.8584 46.4861 14.8643 46.4802 14.8682C46.4683 14.8682 46.4584 14.8682 46.4464 14.8741C46.4365 14.8781 46.4266 14.884 46.4187 14.8918C46.4147 14.9056 46.4068 14.9194 46.3929 14.9253C46.3651 14.9194 46.3453 14.943 46.3333 14.9626C46.3333 14.9843 46.3115 14.9902 46.2976 14.9961C46.248 14.9922 46.25 15.0689 46.1964 15.059C46.1687 15.0748 46.1746 15.1082 46.1429 15.1161C46.1151 15.1141 46.1012 15.1417 46.0814 15.1613C46.0814 15.1672 46.0774 15.1731 46.0734 15.1771C46.0695 15.181 46.0635 15.1849 46.0595 15.1869C46.0318 15.183 46.0159 15.2105 45.9961 15.2203C45.9107 15.1633 45.8234 15.1122 45.7322 15.0649C45.5417 14.9213 45.3591 14.7659 45.1865 14.5987C45.1349 14.6085 45.1449 14.6715 45.0913 14.6597C45.0794 14.6735 45.0496 14.6794 45.0496 14.7069C45.0298 14.7246 45 14.7246 44.9762 14.7344L44.9564 14.7679C44.9365 14.7699 44.9207 14.7777 44.9048 14.7876C44.8889 14.7994 44.877 14.8131 44.8691 14.8308C44.8512 14.8485 44.8175 14.8308 44.8076 14.8564C44.7837 14.8662 44.7818 14.9076 44.746 14.9017C44.6945 14.939 44.6449 15.0118 44.5695 14.9705C44.2599 14.699 43.9782 14.3981 43.7302 14.0695C43.6687 13.9948 43.6131 13.9161 43.5635 13.8354C43.5139 13.7607 43.4663 13.6859 43.4226 13.6092C43.3909 13.5659 43.375 13.5108 43.3393 13.4676C43.3214 13.4341 43.3036 13.4007 43.2897 13.3653C43.1151 13.0584 43.0377 12.7062 43.0695 12.3561C43.0774 12.2735 43.0953 12.1908 43.121 12.1122",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M42.6806 18.421C42.6806 18.421 41.1667 21.0374 32.1012 21.0118C33.5179 22.1862 35.1806 23.0301 36.9683 23.4846C38.756 23.939 40.623 23.9921 42.4345 23.638C42.4345 23.638 43.5536 22.2236 42.6806 18.421Z",
            fill: "#02016F"
          }
        })
      ]),
      _vm._v(" "),
      _c("g", { attrs: { "clip-path": "url(#clip1_778_1196)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M100.303 19.1249C100.286 18.1547 100.282 17.295 100.282 16.249C100.282 15.2766 100.303 14.1679 100.282 13.2431C100.262 12.4224 100.271 11.5691 100.271 10.5296C100.271 10.0445 100.286 9.56161 100.271 9.08734C100.256 8.61524 100.31 8.09983 100.219 7.66671C100.197 7.56276 100.061 7.45015 99.9656 7.36352C99.7793 7.19027 99.6147 7.07117 99.4068 6.88709C99.3397 6.82645 99.1708 6.67269 99.1123 6.67053C99.056 6.67053 98.9456 6.76798 98.8698 6.81129C98.6943 6.91091 98.5861 6.97155 98.3955 7.08199C98.337 7.11664 98.1811 7.18161 98.1638 7.22276C98.1313 7.30505 98.1638 7.55843 98.1638 7.71002V9.16314C98.1638 9.79333 98.1746 10.1745 98.1746 10.8025V12.6476C98.1746 13.2756 98.1703 13.8928 97.9537 14.3303C97.8887 14.4602 97.7675 14.6356 97.67 14.7526C97.5661 14.876 97.4188 14.9626 97.291 15.0666C97.1589 15.1749 97.0138 15.2572 96.8687 15.3373C96.7193 15.4217 96.5959 15.53 96.4573 15.6188C96.2797 15.7336 96.087 15.8289 95.8985 15.9653C95.7838 16.0498 95.6322 16.1299 95.4763 16.2252C95.3766 16.2858 95.3377 16.3486 95.2662 16.2468C95.2337 16.2035 95.1276 16.0519 95.1298 15.9978C95.1319 15.9285 95.2554 15.8332 95.2987 15.7921C95.3723 15.7206 95.4351 15.6621 95.4784 15.5972C95.5217 15.53 95.5456 15.4477 95.5845 15.3806C95.6257 15.307 95.6625 15.2507 95.6906 15.1749C95.8531 14.7266 95.8379 14.0141 95.8379 13.3189C95.8379 12.3336 95.8314 11.2031 95.8271 10.4538C95.8249 9.84097 95.8271 9.18263 95.8271 8.46798C95.8271 8.11282 95.8422 7.7555 95.7535 7.53461C95.7015 7.40467 95.5326 7.24874 95.3745 7.22059C95.1709 7.18378 94.9175 7.24008 94.7205 7.27473C94.1747 7.36785 93.341 7.60607 92.8234 7.35053C92.6025 7.24008 92.3621 6.98454 92.3166 6.67702C92.2712 6.35868 92.4401 5.97104 92.5808 5.72199C92.7628 5.39715 93.0486 5.0918 93.276 4.79945C93.354 4.69983 93.4124 4.59588 93.5077 4.49626C93.5662 4.43562 93.6788 4.56339 93.7611 4.6262C93.8109 4.66518 93.9473 4.74097 93.9517 4.77779C93.956 4.81461 93.7243 5.12645 93.6875 5.17843C93.6463 5.2369 93.5878 5.30403 93.551 5.37333C93.4709 5.52492 93.3994 5.74581 93.5619 5.88441C93.6225 5.93639 93.8217 5.96671 93.9928 5.93855C94.1942 5.90607 94.3675 5.79779 94.5515 5.72199C94.7399 5.6462 94.9413 5.59206 95.1211 5.52709C95.6365 5.33652 96.1021 5.08531 96.8492 5.15894C97.1459 5.18925 97.4166 5.32569 97.5964 5.4946C97.6657 5.55957 97.7501 5.62238 97.7956 5.67868C97.8389 5.73066 97.8692 5.83027 97.9212 5.9169C97.9819 6.01652 98.0338 6.08365 98.0685 6.17677C98.0945 6.2439 98.1226 6.46913 98.1529 6.49078C98.1833 6.51244 98.3522 6.40199 98.4475 6.35002C98.5709 6.28289 98.6619 6.22658 98.7312 6.17677C98.9239 6.03817 99.1491 5.94938 99.3007 5.8411C99.5628 5.65486 99.8421 5.49894 100.143 5.31919C100.219 5.27371 100.373 5.15677 100.427 5.15677C100.474 5.15677 100.615 5.27155 100.691 5.33002C100.786 5.40582 100.856 5.48378 100.923 5.53575C101.009 5.60072 101.107 5.6462 101.187 5.709C101.276 5.7783 101.352 5.86276 101.419 5.91473C101.507 5.98403 101.592 6.03601 101.672 6.09881C101.748 6.15945 101.817 6.23957 101.904 6.30454C101.975 6.35868 102.071 6.40199 102.168 6.47779C102.252 6.54492 102.343 6.67053 102.4 6.67269C102.456 6.67486 102.629 6.5276 102.705 6.47779C102.815 6.40416 102.915 6.35218 103.01 6.29371C103.223 6.16161 103.418 6.03384 103.61 5.91473C103.714 5.85193 103.801 5.77397 103.905 5.709C104 5.64836 104.115 5.60505 104.221 5.53575C104.299 5.48378 104.399 5.39715 104.505 5.33002C104.598 5.27155 104.752 5.15677 104.821 5.15677C104.89 5.15677 105.195 5.34085 105.263 5.38416C105.403 5.47511 105.535 5.56824 105.674 5.6332C105.824 5.70467 105.945 5.81078 106.086 5.89308C106.231 5.9797 106.387 6.03817 106.517 6.12046C106.831 6.31537 107.08 6.47779 107.517 6.42365C107.799 6.389 107.998 6.25473 108.212 6.12046C108.273 6.08148 108.379 6.00136 108.433 6.01218C108.513 6.02951 108.606 6.30021 108.654 6.36951C108.684 6.41282 108.736 6.43015 108.728 6.48862C108.712 6.5839 108.305 6.75932 108.201 6.82429C107.714 7.1318 107.29 7.43066 107.095 8.01753C106.982 8.35753 106.967 8.79499 106.958 9.21078C106.928 10.5405 106.973 12.2101 106.969 13.2691C106.965 14.0661 106.98 14.8587 106.98 15.9285C106.98 16.3681 106.937 16.9961 107.106 17.2408C107.142 17.295 107.229 17.3426 107.307 17.3924C107.374 17.4358 107.463 17.5202 107.517 17.5224C107.591 17.5245 107.814 17.3621 107.874 17.3275C107.905 17.3101 108.182 17.1217 108.242 17.1434C108.284 17.1586 108.336 17.3188 108.359 17.3708C108.392 17.4422 108.463 17.5527 108.455 17.609C108.442 17.6848 108.245 17.7563 108.16 17.8039C108.043 17.871 107.946 17.9468 107.866 17.9988C107.316 18.3583 106.895 18.5662 106.348 18.9214C106.263 18.9755 106.114 19.0946 106.042 19.0946C105.947 19.0946 105.8 18.9344 105.704 18.8672C105.386 18.642 104.985 18.4384 104.819 18.0854C104.645 17.7173 104.665 17.0286 104.671 16.4786C104.691 14.902 104.645 12.9486 104.671 11.5301C104.678 11.149 104.658 10.6856 104.671 10.2719C104.697 9.43167 104.933 8.77117 105.377 8.35104C105.471 8.26225 105.603 8.16696 105.735 8.06951C105.763 8.04785 105.86 7.99804 105.86 7.98289C105.86 7.94174 105.618 7.82913 105.587 7.80964C105.477 7.7425 105.393 7.6862 105.312 7.63639C105.12 7.51295 104.916 7.42199 104.743 7.31155C104.479 7.14263 104.21 6.96722 103.911 6.80047C103.833 6.75715 103.671 6.63804 103.628 6.63804C103.569 6.63804 103.439 6.74632 103.363 6.78964C103.173 6.90225 103.06 6.98021 102.857 7.10365C102.783 7.14913 102.636 7.21193 102.614 7.26607C102.571 7.38085 102.614 7.85728 102.614 8.01537C102.614 9.39919 102.625 10.1745 102.625 11.4868C102.625 12.4397 102.631 13.3926 102.625 14.2437C102.618 15.0926 102.636 15.8202 102.636 16.8597C102.636 17.3816 102.629 17.8364 102.382 18.0854C102.263 18.2045 102.064 18.2912 101.897 18.3886C101.559 18.5879 101.206 18.7265 100.864 18.9084C100.708 18.9907 100.531 19.1358 100.295 19.1141L100.303 19.1249Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M133.745 16.5846C133.946 16.5153 134.067 16.4396 134.26 16.3356C134.301 16.3139 134.399 16.249 134.429 16.2598C134.472 16.2771 134.503 16.4352 134.524 16.4872C134.552 16.5565 134.617 16.6691 134.609 16.7146C134.598 16.7752 134.436 16.838 134.366 16.877C134.109 17.0178 133.844 17.1932 133.608 17.3318C133.264 17.5353 132.92 17.7238 132.597 17.9295C132.426 18.0378 132.257 18.1439 132.09 18.2327C131.666 18.4644 131.269 18.7199 130.836 18.9928C130.756 19.0426 130.626 19.1227 130.572 19.1227C130.479 19.1227 130.327 18.9993 130.234 18.9387C129.714 18.5987 129.193 18.263 128.675 17.9187C128.367 17.7151 127.967 17.5895 127.874 17.1694C127.83 16.9723 127.846 16.7362 127.852 16.5283C127.882 15.6664 127.837 14.3129 127.841 13.1868C127.841 12.8425 127.839 12.4938 127.83 12.1668C127.828 12.0607 127.854 11.9026 127.83 11.8853C127.796 11.8593 127.662 11.9481 127.62 11.9719C127.417 12.0845 127.276 12.208 127.051 12.2751C127.04 12.1646 127.051 12.0672 127.051 11.9827C127.051 11.9091 127.016 11.7943 127.051 11.7229C127.079 11.6666 127.261 11.5778 127.367 11.5171C127.495 11.4413 127.62 11.3655 127.694 11.3222C127.798 11.2616 127.924 11.2075 128.032 11.1382C128.144 11.0667 128.242 10.9736 128.337 10.9216C128.441 10.8653 128.556 10.8306 128.643 10.7808C128.74 10.7245 128.824 10.6227 128.907 10.5751C129.006 10.5166 129.119 10.4928 129.245 10.4235C129.344 10.3672 129.437 10.2806 129.539 10.2178C129.641 10.155 129.749 10.1052 129.855 10.0445C130.364 9.75217 130.862 9.43382 131.393 9.12197C131.488 9.06567 131.679 8.98771 131.698 8.9379C131.731 8.85344 131.698 8.60006 131.687 8.47229C131.661 8.12363 131.57 7.8486 131.434 7.61471C131.317 7.41331 131.094 7.17076 130.897 7.01701C130.728 6.88707 130.581 6.81127 130.382 6.69217C130.299 6.64452 130.176 6.52108 130.106 6.51892C130.054 6.51892 129.953 6.59688 129.886 6.63803C129.723 6.73548 129.617 6.78962 129.455 6.88707C129.39 6.92605 129.288 7.00401 129.234 7.00618C129.145 7.01051 129.028 6.92822 128.95 6.88707C128.857 6.83943 128.781 6.80911 128.686 6.74631C128.987 6.50809 129.344 6.33484 129.676 6.12694C129.784 6.05981 129.899 5.99484 130.013 5.93204C130.124 5.86924 130.232 5.79127 130.34 5.72631C130.455 5.65701 130.576 5.60936 130.689 5.54223C130.799 5.4751 130.897 5.38847 131.005 5.32567C131.12 5.25854 131.239 5.20223 131.354 5.14159C131.44 5.09395 131.547 5.20006 131.648 5.2607C131.889 5.4058 132.138 5.55739 132.365 5.70465C132.588 5.84975 132.811 6.03382 132.987 6.24822C133.045 6.31968 133.123 6.37599 133.177 6.44312C133.273 6.56656 133.366 6.73331 133.442 6.88707C133.517 7.04732 133.584 7.22057 133.632 7.39815C133.732 7.77497 133.727 8.22108 133.727 8.68885C133.727 9.72401 133.738 10.4278 133.738 11.359C133.738 13.1825 133.734 15.1077 133.749 16.589L133.745 16.5846ZM131.542 9.89943C131.356 10.0207 131.152 10.1117 130.973 10.2351C130.88 10.3001 130.793 10.3672 130.698 10.4192C130.598 10.4733 130.49 10.5101 130.392 10.5708C130.312 10.6184 130.258 10.6942 130.15 10.7657C130.076 10.8155 129.909 10.8653 129.886 10.9281C129.864 10.9866 129.886 11.1446 129.886 11.2746C129.886 12.1798 129.866 12.732 129.886 13.3471C129.899 13.778 129.896 14.2003 129.896 14.6053C129.896 15.0341 129.862 15.5083 129.896 15.9934C129.925 16.4049 130.111 16.5175 130.382 16.7103C130.527 16.8142 130.678 16.8813 130.823 16.981C130.927 17.0524 131.059 17.1607 131.246 17.2733C131.317 17.3166 131.622 17.5743 131.698 17.5115C131.737 17.4812 131.72 17.1607 131.72 17.0134C131.72 16.4807 131.709 15.8635 131.72 15.4845C131.739 14.7504 131.726 14.2696 131.72 13.5745C131.713 12.9443 131.711 12.6086 131.709 11.9351C131.709 11.398 131.709 10.5989 131.709 10.1441C131.709 10.0034 131.698 9.86045 131.562 9.88427C131.549 9.88643 131.549 9.89076 131.54 9.89509L131.542 9.89943Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M81.8331 8.46796C81.8439 8.30987 81.8179 8.22974 81.8114 8.12146C81.8093 8.06299 81.7963 7.95688 81.8222 7.89407C81.8526 7.82044 82.0865 7.67968 82.1601 7.62337C82.3225 7.49777 82.5261 7.43496 82.5607 7.22273C82.6019 6.9607 82.3788 6.6207 82.2662 6.47344C82.0193 6.15076 81.6988 5.90605 81.2029 5.81076C80.8131 5.73713 80.2912 5.94936 80.0746 6.16809C80.04 6.20273 80.014 6.2677 79.9685 6.31968C79.9273 6.36949 79.871 6.40414 79.8429 6.44961C79.8126 6.49726 79.7909 6.57522 79.7584 6.64452C79.3101 7.58439 79.4986 9.01802 79.6848 10.1701C79.7649 10.6704 79.8667 11.2161 79.9598 11.7553C80.0031 12.0066 80.0465 12.2924 80.0659 12.5696C80.1093 13.2193 80.1071 13.8517 79.8667 14.3497C79.8277 14.432 79.7584 14.5165 79.7086 14.5988C79.5679 14.8262 79.3946 15.0297 79.1824 15.1965C79.0719 15.281 78.9615 15.3286 78.877 15.3914C78.7774 15.4629 78.7124 15.543 78.6128 15.6188C78.4894 15.7162 78.3183 15.792 78.171 15.922C78.1191 15.9674 78.0498 16.0216 77.961 16.0844C77.9047 16.1234 77.8094 16.2403 77.7401 16.236C77.6881 16.2338 77.5105 16.0108 77.5084 15.9545C77.5062 15.8765 77.6491 15.7271 77.6773 15.6621C77.8549 15.2571 77.8852 14.7634 77.857 14.2198C77.8549 14.1592 77.8722 14.0964 77.8679 14.0249C77.8484 13.6503 77.7921 13.2799 77.7314 12.9074C77.6188 12.2231 77.4975 11.5193 77.3633 10.7917C77.3329 10.6249 77.3178 10.4495 77.3005 10.2806C77.2831 10.1008 77.2377 9.92974 77.2268 9.75866C77.1619 8.69751 77.3698 7.98286 77.7336 7.29637C77.9783 6.83509 78.3638 6.39981 78.7774 6.09229C78.8489 6.03815 78.9268 5.99267 78.9983 5.9407C79.0698 5.88872 79.1304 5.82375 79.1975 5.77828C79.3015 5.70898 79.4271 5.65917 79.5462 5.60503C79.8645 5.45777 80.2738 5.26936 80.6831 5.21522C81.1163 5.15675 81.5321 5.16108 81.9998 5.21522C82.2207 5.24121 82.4481 5.25853 82.6322 5.31267C82.8812 5.3863 83.1281 5.54006 83.349 5.64834C83.4659 5.70681 83.5634 5.77178 83.6652 5.85407C83.7691 5.93853 83.8861 5.997 83.9705 6.07063C84.068 6.15509 84.1568 6.27637 84.265 6.39547C84.3019 6.43662 84.3517 6.49076 84.4015 6.56872C84.434 6.61853 84.5184 6.73547 84.5184 6.7528C84.5141 6.80261 84.2715 6.94554 84.2022 6.99101C84.0723 7.07547 83.9532 7.12961 83.8536 7.19675C83.741 7.27254 83.637 7.357 83.5266 7.42414C83.1844 7.6342 82.8509 7.83777 82.5152 8.06516C82.2943 8.21458 82.0735 8.36401 81.8417 8.46796H81.8331Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M77.4065 7.18811C77.4022 7.29639 77.3112 7.31588 77.2376 7.35053C77.2788 7.28123 77.3047 7.19461 77.4065 7.18811Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M92.843 7.83781C92.8733 7.77068 93.079 7.68189 93.0855 7.77285C93.0877 7.80966 92.9166 7.87463 92.843 7.83781Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M135.38 12.0391C135.423 11.9048 135.323 11.6125 135.38 11.4847C135.393 11.4566 135.596 11.3439 135.674 11.3006C135.791 11.2335 135.891 11.1772 135.969 11.1274C136.172 10.9953 136.395 10.8892 136.569 10.7809C136.66 10.7224 136.759 10.625 136.844 10.5752C136.954 10.508 137.078 10.4734 137.182 10.4127C137.283 10.3543 137.366 10.2698 137.465 10.207C137.623 10.1096 137.792 10.0338 137.95 9.93631C138.403 9.65261 138.897 9.37758 139.362 9.08955C139.429 9.04841 139.501 9.15885 139.562 9.23032C139.804 9.50752 140.038 9.78904 140.289 10.0554C140.393 10.1659 140.473 10.2828 140.564 10.3911C140.618 10.4582 140.701 10.4972 140.755 10.5535C140.807 10.6076 140.844 10.7138 140.902 10.7809C140.95 10.8372 141.045 10.8913 141.101 10.9541C141.147 11.0039 141.19 11.0992 141.238 11.1599C141.296 11.2313 141.374 11.2833 141.437 11.3548C141.556 11.489 141.673 11.6276 141.805 11.7771C141.827 11.8009 141.987 11.9763 141.985 11.9936C141.981 12.0304 141.807 12.1257 141.764 12.1561C141.539 12.3141 141.257 12.4614 141.058 12.6C140.902 12.7104 140.735 12.7906 140.584 12.8924C139.902 13.3471 139.183 13.7629 138.477 14.2372C138.405 14.2848 138.271 14.3563 138.256 14.3888C138.217 14.4732 138.256 14.718 138.256 14.8219C138.256 14.9995 138.254 15.1403 138.256 15.3092C138.262 15.7033 138.21 16.0022 138.256 16.3075C138.292 16.5479 138.533 16.6865 138.708 16.8056C139.031 17.0243 139.332 17.2301 139.668 17.4791C139.724 17.5203 139.821 17.6069 139.858 17.609C139.919 17.6134 140.001 17.5332 140.057 17.5008C140.391 17.308 140.694 17.1608 141.036 16.968C141.084 16.942 141.142 16.8987 141.227 16.8597C141.277 16.8359 141.404 16.758 141.426 16.7623C141.487 16.7753 141.53 16.9377 141.563 17.0222C141.597 17.1131 141.692 17.2431 141.679 17.3037C141.666 17.36 141.37 17.5051 141.311 17.5419C140.553 18.0075 139.83 18.4385 139.057 18.8976C138.99 18.9387 138.756 19.1141 138.678 19.1141C138.604 19.1141 138.448 18.9929 138.373 18.9409C138.085 18.7373 137.797 18.5489 137.519 18.354C137.327 18.2197 137.132 18.1201 136.939 17.975C136.599 17.7152 136.248 17.6415 136.211 17.0958C136.192 16.7969 136.216 16.5219 136.211 16.2707C136.201 15.4283 136.201 14.7526 136.201 13.6871C136.201 13.1696 136.205 12.5783 136.201 12.1344C136.201 12.0066 136.229 11.6536 136.19 11.6147C136.157 11.58 135.839 11.8096 135.8 11.8312C135.642 11.92 135.538 11.9741 135.378 12.0261L135.38 12.0391ZM139.141 12.9725C139.328 12.8404 139.572 12.7278 139.774 12.5827C139.826 12.5437 139.962 12.4527 139.964 12.4203C139.964 12.3986 139.904 12.351 139.869 12.312C139.763 12.195 139.668 12.0564 139.585 11.9655C139.25 11.5995 138.951 11.1794 138.626 10.8264C138.555 10.7484 138.513 10.6445 138.446 10.5773C138.429 10.5578 138.312 10.638 138.299 10.6856C138.271 10.7809 138.299 10.9498 138.299 11.0538C138.299 12.0001 138.295 12.6325 138.31 13.5052C138.598 13.3406 138.86 13.1739 139.141 12.9725Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M110.049 11.6363C109.834 11.7402 109.663 11.8463 109.427 11.9719C109.377 11.9979 109.245 12.0889 109.217 12.0586C109.178 12.0196 109.221 11.8615 109.228 11.7446C109.232 11.6839 109.206 11.5605 109.228 11.5063C109.245 11.463 109.449 11.3699 109.533 11.3223C109.743 11.201 109.919 11.0754 110.122 10.9541C110.233 10.887 110.345 10.8458 110.438 10.7917C110.532 10.7354 110.631 10.6228 110.711 10.5751C110.807 10.5167 110.919 10.4885 111.017 10.4344C111.112 10.3824 111.192 10.3109 111.281 10.2503C111.372 10.1875 111.467 10.1507 111.565 10.0987C111.753 9.99692 111.933 9.86914 112.112 9.76303C112.485 9.53997 112.851 9.31475 113.219 9.11118C113.299 9.06787 113.479 9.19564 113.587 9.26278C113.691 9.32558 113.804 9.39055 113.893 9.44685C114.222 9.65258 114.499 9.83016 114.819 10.0121C115.032 10.1312 115.231 10.2676 115.43 10.3911C115.543 10.4625 115.664 10.508 115.768 10.5751C115.989 10.7202 116.123 10.9238 116.147 11.2811C116.177 11.7467 116.147 12.1863 116.147 12.626C116.147 13.8777 116.158 14.7959 116.158 16.2404C116.158 16.3573 116.151 16.563 116.169 16.576C116.201 16.602 116.452 16.4591 116.496 16.4353C116.543 16.4114 116.721 16.2534 116.801 16.2728C116.842 16.2815 117.015 16.641 117 16.706C116.992 16.7514 116.79 16.8619 116.758 16.8792C116.299 17.1304 115.926 17.3795 115.493 17.6393C115.32 17.7433 115.138 17.8321 114.978 17.9317C114.367 18.3107 113.832 18.616 113.208 18.995C113.119 19.0491 113.011 19.1358 112.944 19.1358C112.844 19.1358 112.691 19.0015 112.595 18.9409C112.264 18.7243 111.9 18.5316 111.595 18.3432C111.374 18.2089 111.155 18.066 110.93 17.9317C110.607 17.7368 110.183 17.5917 110.088 17.1607C110.021 16.8619 110.062 16.5024 110.055 16.2165C110.038 15.2247 110.064 13.9188 110.055 12.8533C110.051 12.4181 110.046 12.0781 110.044 11.6384L110.049 11.6363ZM112.167 10.7137C112.084 10.744 112.104 10.9455 112.104 11.0061C112.099 11.3439 112.108 11.7056 112.115 11.9719C112.123 12.3228 112.115 13.0179 112.115 13.4922C112.115 14.0747 112.115 14.5577 112.115 15.0319C112.115 15.4997 112.058 16.1646 112.232 16.4201C112.314 16.5435 112.52 16.6302 112.663 16.7233C113.057 16.981 113.446 17.1802 113.832 17.4184C113.849 17.4293 114.012 17.5787 114.085 17.5159C114.12 17.4856 114.107 17.2712 114.107 17.1694V16.0628C114.107 14.6811 114.096 14.0141 114.096 12.6346C114.096 12.4094 114.131 12.1452 114.064 11.9611C114.016 11.8312 113.806 11.6449 113.685 11.5713C113.507 11.4609 113.356 11.3807 113.189 11.2898C112.916 11.1382 112.725 10.9931 112.461 10.8567C112.383 10.8155 112.255 10.7029 112.186 10.7159C112.18 10.7159 112.171 10.7159 112.164 10.7159L112.167 10.7137Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M82.7188 12.0607C82.7231 11.9568 82.7079 11.8788 82.7079 11.79C82.7079 11.7272 82.6863 11.5886 82.7188 11.5193C82.7383 11.4738 82.9288 11.3785 83.0241 11.3244C83.1389 11.2594 83.2515 11.2053 83.3403 11.1511C83.4421 11.0883 83.533 11.0061 83.6348 10.9454C83.7474 10.8804 83.8687 10.8415 83.9618 10.783C84.0484 10.7289 84.1286 10.6336 84.2044 10.5881C84.3408 10.5036 84.4946 10.456 84.6267 10.3715C84.7544 10.2892 84.867 10.1896 84.9948 10.1117C85.1399 10.0229 85.2937 9.96656 85.4366 9.87344C85.8394 9.6114 86.279 9.36886 86.7013 9.12414C86.7944 9.07 86.9677 9.3472 87.0391 9.42733C87.2384 9.65688 87.4095 9.85395 87.6195 10.0683C87.73 10.181 87.8058 10.3066 87.8946 10.404C87.9574 10.4733 88.0505 10.5231 88.1046 10.5881C88.1588 10.6509 88.1848 10.7418 88.2302 10.7938C88.2779 10.848 88.3753 10.9043 88.4295 10.9671C88.4793 11.0255 88.5291 11.1317 88.5876 11.1945C88.6352 11.2464 88.7197 11.3114 88.7868 11.3894C88.9189 11.5388 89.0034 11.6492 89.1549 11.8117C89.1853 11.8441 89.3347 11.9871 89.3347 12.0174C89.3325 12.0672 89.1658 12.156 89.1138 12.1906C88.8842 12.3509 88.6092 12.496 88.4078 12.6346C88.109 12.8425 87.7733 13.0244 87.4593 13.2215C86.9222 13.5593 86.3743 13.9015 85.8264 14.274C85.7398 14.3324 85.6142 14.3736 85.5947 14.4255C85.56 14.5187 85.5947 14.7742 85.5947 14.9236C85.5947 15.2182 85.5925 15.5906 85.5947 15.9003C85.5969 16.171 85.5817 16.3984 85.7008 16.5522C85.7853 16.6626 85.9325 16.7449 86.069 16.8337C86.3353 17.0069 86.5476 17.1824 86.8269 17.3773C86.8789 17.4141 86.9482 17.4552 87.0175 17.5072C87.1951 17.6415 87.2124 17.6566 87.4181 17.5397C87.7516 17.3491 88.044 17.1932 88.3883 16.9961C88.4338 16.9701 88.711 16.7817 88.789 16.8012C88.8539 16.8185 88.8907 16.9766 88.9254 17.0611C88.9644 17.1542 89.0575 17.2885 89.0423 17.3426C89.0358 17.3686 88.9081 17.4271 88.8518 17.4617C88.6655 17.583 88.4641 17.6999 88.2822 17.7974C87.9985 17.9533 87.7755 18.1157 87.5351 18.2522C87.1626 18.4622 86.7814 18.6853 86.3981 18.9257C86.3028 18.9863 86.1079 19.1444 86.0191 19.1422C85.939 19.1422 85.7961 19.0101 85.7246 18.9582C85.4409 18.7568 85.1399 18.5835 84.8605 18.3821C84.6765 18.25 84.4751 18.1482 84.2802 18.0031C83.9467 17.7519 83.6002 17.6545 83.5525 17.1239C83.5092 16.6236 83.559 16.0952 83.5525 15.6599C83.546 15.2355 83.5612 14.759 83.5525 14.3909C83.5395 13.7607 83.5417 12.888 83.5417 11.9936C83.5417 11.8745 83.546 11.6557 83.5309 11.6471C83.4941 11.6233 83.362 11.7294 83.3208 11.7554C83.1281 11.8745 82.9115 11.9936 82.7209 12.0585L82.7188 12.0607ZM86.4479 13.0049C86.6298 12.8771 86.8724 12.7515 87.0695 12.6043C87.1258 12.561 87.2579 12.4852 87.26 12.4418C87.26 12.4289 87.1734 12.3314 87.1539 12.3119C87.0543 12.1993 87.0067 12.1343 86.9222 12.0304C86.8811 11.9784 86.8313 11.9394 86.7858 11.8896C86.6125 11.7077 86.4566 11.4738 86.2898 11.2919C86.1967 11.1901 86.1296 11.0754 86.0473 10.9779C85.9997 10.9194 85.9282 10.8761 85.8784 10.8155C85.8264 10.7527 85.7874 10.679 85.742 10.6206C85.7246 10.5989 85.6098 10.6682 85.5947 10.6964C85.5687 10.7483 85.5839 10.9714 85.5839 11.0537C85.5839 11.8376 85.5904 12.5675 85.6055 13.5268C85.8849 13.3471 86.1599 13.2106 86.4479 13.0071V13.0049Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M119.679 9.13067C119.694 9.13067 119.683 9.11984 119.701 9.13067C119.919 9.29093 120.106 9.5573 120.322 9.78252C120.478 9.94494 120.63 10.0814 120.786 10.2698C120.84 10.3369 120.885 10.4365 120.922 10.443C120.987 10.4539 121.141 10.3153 121.206 10.2698C121.305 10.2005 121.412 10.1485 121.49 10.1074C121.702 9.99691 121.886 9.87131 122.059 9.77169C122.336 9.61144 122.631 9.45335 122.923 9.28443C123.001 9.23895 123.155 9.12201 123.207 9.12201C123.27 9.12201 123.402 9.23895 123.46 9.28443C123.69 9.46201 123.93 9.64609 124.145 9.81717C124.482 10.0857 124.993 10.3131 125.071 10.8263C125.108 11.0646 125.082 11.3461 125.082 11.6081C125.082 12.8122 125.097 14.4277 125.093 16.0671C125.093 16.5067 125.076 16.9333 125.145 17.282C125.173 17.4249 125.312 17.5397 125.44 17.6285C125.509 17.6761 125.617 17.7584 125.66 17.7584C125.728 17.7584 125.946 17.6155 126.018 17.5744C126.055 17.5527 126.306 17.3643 126.366 17.3795C126.403 17.3881 126.451 17.5116 126.483 17.5852C126.509 17.6502 126.577 17.7693 126.568 17.8126C126.559 17.8559 126.358 17.9577 126.315 17.9858C125.782 18.3302 125.251 18.6139 124.734 18.9517C124.664 18.9972 124.528 19.1011 124.469 19.1033C124.402 19.1033 124.244 18.9885 124.186 18.9517C124.06 18.8759 123.993 18.8369 123.913 18.7893C123.627 18.6247 123.324 18.4688 123.196 18.1591C123.016 17.726 123.07 17.1261 123.07 16.5089C123.07 16.0173 123.055 15.517 123.06 14.9886C123.064 14.4061 123.06 13.3233 123.06 12.4484C123.06 11.933 123.062 11.6103 122.795 11.3526C122.726 11.2854 122.626 11.2465 122.542 11.1793C122.462 11.1165 122.401 11.0277 122.321 10.9628C122.237 10.8935 122.135 10.848 122.057 10.7895C122.014 10.7549 121.903 10.586 121.847 10.5838C121.797 10.5816 121.661 10.7202 121.583 10.7679C121.516 10.8112 121.405 10.8523 121.308 10.8978C121.241 10.9303 121.082 11.0083 121.065 11.0494C121.03 11.136 121.065 11.3699 121.065 11.515C121.065 12.4939 121.059 13.7629 121.065 14.4559C121.074 15.2593 121.076 16.2295 121.076 17.1477C121.076 17.6112 121.117 18.0465 120.896 18.2868C120.855 18.3323 120.792 18.3821 120.738 18.4168C120.489 18.5792 120.242 18.6485 119.906 18.7958C119.785 18.8499 119.642 18.9235 119.495 18.9907C119.458 19.008 119.133 19.2051 119.042 19.1098C119.014 19.0795 119.021 18.6745 119.021 18.655C119.021 17.3145 118.997 15.4521 119.01 14.1527C119.016 13.555 119.01 12.6476 119.01 11.7879C119.01 11.6103 119.04 11.4067 119.01 11.266C118.993 11.188 118.886 11.0862 118.819 11.0061C118.744 10.9151 118.655 10.8458 118.598 10.7787C118.544 10.7137 118.495 10.5643 118.419 10.5513C118.31 10.5318 118.189 10.7094 118.103 10.7679C118.042 10.809 117.936 10.8545 117.849 10.8978C117.769 10.939 117.648 11.0407 117.607 11.0386C117.544 11.0364 117.455 10.8956 117.416 10.8545C117.39 10.8263 117.249 10.7181 117.258 10.6379C117.267 10.56 117.546 10.456 117.607 10.4214C117.778 10.3218 117.931 10.1853 118.113 10.0857C118.46 9.89297 118.8 9.66558 119.136 9.44468C119.302 9.3364 119.48 9.21513 119.651 9.13067C119.655 9.12851 119.666 9.13067 119.673 9.13067H119.679Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M112.515 11.2465C112.515 11.2833 112.446 11.3483 112.42 11.3223C112.381 11.2855 112.446 11.1967 112.515 11.2465Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M85.9217 11.3764C86.0235 11.3027 85.9758 11.541 85.9 11.463C85.8654 11.4262 85.9108 11.3829 85.9217 11.3764Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M138.76 11.5171C138.977 11.4976 138.641 11.7012 138.613 11.6795C138.533 11.6211 138.719 11.5193 138.76 11.5171Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M86.0581 11.5497C86.1729 11.541 86.0971 11.6146 86.0256 11.6579C85.9823 11.6839 85.8394 11.7662 85.9 11.6363C85.913 11.6103 86.0235 11.5518 86.0581 11.5497Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M76.9019 16.1624C76.8911 16.0606 77.0643 15.9458 77.1228 15.9891C77.1921 16.0411 76.9431 16.1732 76.9019 16.1624Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M78.851 16.2923C78.9528 16.2815 79.1001 16.2923 79.2192 16.3032C79.3404 16.314 79.4595 16.288 79.5873 16.3032C79.661 16.3118 79.7411 16.3421 79.819 16.3573C80.2218 16.4353 80.5597 16.5024 80.8824 16.6713C81.2202 16.8489 81.4194 17.0265 81.662 17.269C81.7139 17.321 81.8179 17.4704 81.8612 17.4747C81.9673 17.4856 82.1947 17.2062 82.3138 17.2365C82.3658 17.2495 82.4199 17.3946 82.4502 17.4531C82.4762 17.5029 82.5694 17.648 82.5564 17.7021C82.5455 17.7476 82.3571 17.8364 82.2813 17.8862C81.7313 18.2522 81.2137 18.577 80.6788 18.9712C80.6138 19.021 80.4471 19.1401 80.3951 19.1336C80.3323 19.1271 80.2478 18.9582 80.2045 18.8954C79.8125 18.3258 79.1477 18.0118 78.2338 17.9295C78.1212 17.9187 77.9913 17.9425 77.896 17.9512C77.8159 17.9577 77.7271 17.9447 77.6426 17.9512C77.3762 17.9728 77.0925 18.0443 76.8305 18.1028C76.0444 18.2804 75.3601 18.577 74.7559 18.917C74.6671 18.9668 74.5999 19.0232 74.4808 19.0903C74.4115 19.1293 74.2556 19.2549 74.2058 19.2527C74.1646 19.2527 74.0022 19.0925 74.0066 19.0253C74.0066 18.982 74.143 18.8629 74.2166 18.7763C74.2967 18.6853 74.3639 18.5879 74.4267 18.5272C75.059 17.9252 75.7499 17.3925 76.5338 16.9853C76.9301 16.7796 77.3697 16.5998 77.8288 16.4656C78.0649 16.3963 78.3226 16.327 78.5673 16.3032C78.6453 16.2945 78.7622 16.301 78.8424 16.2923H78.851Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M95.2143 16.5414C96.0069 16.5024 96.6198 16.6649 97.1309 16.9745C97.2846 17.0677 97.4124 17.1759 97.5531 17.3102C97.5921 17.347 97.6679 17.4163 97.6896 17.4185C97.7307 17.4228 97.8498 17.3427 97.9105 17.3102C98.0794 17.2236 98.1574 17.1759 98.3328 17.072C98.3912 17.0373 98.493 16.9485 98.5428 16.9637C98.5905 16.9789 98.6403 17.1521 98.6793 17.2344C98.7074 17.295 98.8005 17.4163 98.7962 17.4618C98.7875 17.5506 98.5667 17.6307 98.4692 17.6892C97.7762 18.1071 97.1222 18.497 96.4249 18.9257C96.3404 18.9777 96.1368 19.1336 96.0762 19.1206C96.0264 19.1098 95.9874 18.9756 95.9593 18.9257C95.6344 18.3107 94.9977 17.9296 93.9886 18.0032C93.4082 18.0465 92.778 18.2284 92.2929 18.4255C91.9745 18.5554 91.5588 18.7525 91.2491 18.9799C91.1711 19.0362 90.9892 19.1899 90.9329 19.1856C90.9026 19.1856 90.7012 18.9647 90.7012 18.9149C90.7012 18.8846 90.8917 18.6962 90.9654 18.6226C91.4353 18.1396 91.9442 17.7715 92.5138 17.4077C92.6199 17.3405 92.7542 17.2864 92.8819 17.2236C93.0097 17.1608 93.1245 17.0763 93.2306 17.0287C93.4363 16.9334 93.6919 16.8728 93.9258 16.7905C94.3351 16.6475 94.6902 16.5674 95.2121 16.5414H95.2143Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M131.417 16.8553C131.419 16.9484 131.274 16.9658 131.269 16.9095C131.267 16.8813 131.376 16.8315 131.417 16.8553Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M113.789 16.8661C113.852 16.9831 113.665 17.0156 113.652 16.9528C113.641 16.9073 113.745 16.8856 113.789 16.8661Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M77.8916 18.2673C77.8786 18.328 77.7313 18.4038 77.701 18.3106C77.7551 18.2868 77.8158 18.2695 77.8916 18.2673Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M93.9171 18.3432C93.8998 18.3995 93.8153 18.4385 93.7482 18.4082C93.7633 18.3432 93.837 18.3389 93.9171 18.3432Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M92.0547 5.88442C92.0915 5.83895 92.1391 5.8043 92.176 5.75665",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M91.7991 6.2655C91.8597 6.18538 91.955 6.15073 92.0351 6.09442",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M80.7935 6.27854C80.8888 6.23523 80.9668 6.15294 81.0685 6.12262",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M81.0101 6.38898C81.1249 6.3435 81.231 6.27853 81.335 6.21356",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.2332 6.50592C81.3458 6.44095 81.4605 6.37814 81.5797 6.32184",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M91.6649 6.57516C91.7601 6.4972 91.8706 6.44306 91.9789 6.38892",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.3739 6.6835C81.5017 6.60987 81.6229 6.52758 81.7529 6.45612",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.5212 6.84586C81.6511 6.77223 81.7832 6.70293 81.911 6.62714",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M91.6042 6.8459C91.7169 6.77011 91.8425 6.71813 91.9594 6.64667",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.649 7.02997C81.7768 6.95634 81.9002 6.87405 82.0301 6.80475",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M91.9962 6.86969C91.8706 6.94332 91.7429 7.02345 91.6129 7.08842",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.7528 7.20328C81.8806 7.12749 82.0127 7.05819 82.1404 6.98456",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.189 6.96716C130.061 7.02563 129.948 7.11009 129.821 7.1664",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M91.6627 7.3028C91.7948 7.22483 91.9291 7.14904 92.0634 7.07324",
            stroke: "#02016F",
            "stroke-width": "0.0541401",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.022 7.30067C130.139 7.23137 130.256 7.15558 130.379 7.09711",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.363 7.28982C103.474 7.22268 103.586 7.15122 103.706 7.09924",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M81.8265 7.41985C81.9607 7.33755 82.0885 7.24443 82.2163 7.15997",
            stroke: "#02016F",
            "stroke-width": "0.0519745",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M98.8287 7.41328C98.9608 7.35481 99.0756 7.25735 99.2055 7.19672",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.558 7.43068C103.678 7.36571 103.797 7.29641 103.911 7.22278",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.21 7.44148C130.34 7.37867 130.462 7.30071 130.585 7.22491",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M91.7731 7.49777C91.9096 7.42847 92.0417 7.35268 92.1738 7.27039",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.0063 7.54537C99.1297 7.48256 99.251 7.4176 99.3723 7.34613",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.773 7.54757C103.89 7.50426 104 7.42847 104.113 7.37",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.39 7.58437C130.514 7.51507 130.641 7.45227 130.767 7.38513",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M91.9399 7.62984C92.059 7.56054 92.1803 7.49557 92.3038 7.43494",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.199 7.68831C99.3181 7.61251 99.4459 7.54538 99.5715 7.48041",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.981 7.67534C104.098 7.61254 104.215 7.54108 104.334 7.4826",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.537 7.76629C130.663 7.6775 130.795 7.60171 130.927 7.52808",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.0081 7.71653C77.0579 7.64073 77.1488 7.61908 77.2116 7.55627",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M92.1738 7.75762C92.2756 7.69482 92.3773 7.62335 92.4856 7.56921",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.8613 7.70354C94.948 7.65373 95.0302 7.59093 95.1255 7.56061",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.197 7.80967C104.318 7.74687 104.429 7.66241 104.55 7.59528",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.3527 7.8594C99.487 7.78794 99.6126 7.70131 99.7404 7.62335",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.9869 7.87885C95.1255 7.81821 95.2467 7.72726 95.3789 7.65363",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M92.451 7.83991C92.5528 7.81393 92.6416 7.73596 92.7325 7.68182",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.657 7.93738C130.793 7.86591 130.929 7.79228 131.059 7.70782",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.754 7.73596C104.639 7.80526 104.522 7.87239 104.401 7.93087",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.4827 8.01536C99.6148 7.94823 99.7469 7.88326 99.8769 7.80963",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.0605 8.07167C95.1862 7.99154 95.3183 7.92657 95.4504 7.86377",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.604 8.04565C104.726 7.98718 104.845 7.92221 104.966 7.86157",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M76.8326 8.04786C76.8975 7.97207 77.0058 7.9634 77.0773 7.8941",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.761 8.11924C130.888 8.03261 131.027 7.96764 131.163 7.89618",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.819 8.19074C104.938 8.11711 105.053 8.03482 105.178 7.97852",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5282 8.24274C99.656 8.17127 99.7794 8.08681 99.905 8.01318",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1104 8.29475C95.2316 8.23195 95.3464 8.15832 95.4633 8.08685",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.858 8.31418C130.992 8.24271 131.126 8.16692 131.254 8.08246",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M76.707 8.37485C76.7677 8.29039 76.8911 8.2709 76.9712 8.2016",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5585 8.48101C99.6754 8.41604 99.7902 8.34024 99.9093 8.28394",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.912 8.52426C131.046 8.44847 131.181 8.37051 131.315 8.29688",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1125 8.54592C95.2273 8.47878 95.3399 8.41165 95.4547 8.34668",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.6074 8.66936C76.7049 8.58706 76.8348 8.55025 76.9279 8.46362",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5629 8.72572C99.682 8.65642 99.8011 8.58712 99.9224 8.52216",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.958 8.75159C131.083 8.6758 131.215 8.60866 131.339 8.5307",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1255 8.7906C95.2403 8.72131 95.355 8.65634 95.472 8.59137",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.5511 8.95087C76.6551 8.86642 76.7915 8.8231 76.8933 8.73431",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.964 8.98337C131.092 8.90541 131.224 8.82961 131.352 8.75165",
            stroke: "#02016F",
            "stroke-width": "0.0498089",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5607 8.97258C99.6798 8.90544 99.8011 8.83831 99.9181 8.76685",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1276 9.0331C95.2446 8.96596 95.3637 8.90099 95.4806 8.82953",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M76.5078 9.2021C76.6313 9.13496 76.7547 9.06566 76.876 8.98987",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5715 9.21513C99.6863 9.148 99.8011 9.0787 99.918 9.01373",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1212 9.28221C95.2424 9.22374 95.355 9.14578 95.472 9.08081",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.316 9.2389C104.375 9.16744 104.472 9.14578 104.539 9.08514",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.5143 9.44686C76.6247 9.37973 76.7417 9.31692 76.8543 9.25629",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5585 9.4576C99.6776 9.39479 99.801 9.32549 99.918 9.25403",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1276 9.52907C95.2424 9.4641 95.3572 9.39697 95.472 9.32983",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.147 9.57025C104.238 9.49445 104.349 9.45114 104.446 9.38617",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.4862 9.70024C76.6161 9.63744 76.7417 9.56381 76.8674 9.49451",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5629 9.70229C99.682 9.63732 99.8032 9.57668 99.918 9.50305",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1255 9.76513C95.2424 9.69799 95.3637 9.64385 95.4763 9.57239",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.059 9.86263C104.158 9.78033 104.279 9.73702 104.383 9.66339",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.5056 9.95576C76.6247 9.88429 76.7416 9.80633 76.865 9.74353",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5607 9.96009C99.6798 9.88646 99.7968 9.8085 99.9181 9.74353",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1276 10.0185C95.2446 9.9514 95.3637 9.88643 95.472 9.80847",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.996 10.1311C104.113 10.0597 104.245 10.0098 104.353 9.92755",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.5056 10.1788C76.6355 10.1117 76.7676 10.0445 76.8954 9.97089",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.918 10.0034C99.7989 10.0683 99.6754 10.129 99.5585 10.1961",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1212 10.2741C95.2273 10.1853 95.3572 10.1311 95.4785 10.0662",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.985 10.4039C104.102 10.3346 104.208 10.2545 104.323 10.183",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M76.536 10.4365C76.6681 10.3672 76.7872 10.2762 76.915 10.1961",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5649 10.4495C99.6927 10.3954 99.8075 10.3153 99.9201 10.233",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1255 10.5058C95.2489 10.4582 95.3702 10.3932 95.4785 10.3131",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M76.5576 10.653C76.6746 10.5664 76.811 10.5123 76.9388 10.4495",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.939 10.666C104.046 10.5707 104.184 10.5187 104.312 10.4603",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.973 10.7094C131.092 10.6163 131.224 10.547 131.358 10.482",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5649 10.692C99.6689 10.6097 99.7858 10.5512 99.9028 10.4949",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1212 10.77C95.2446 10.705 95.3485 10.6032 95.4763 10.5469",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.5987 10.8783C76.7265 10.822 76.8499 10.7549 76.9582 10.6661",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.948 10.9042C104.069 10.8436 104.204 10.7938 104.306 10.6985",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.99 10.9367C131.113 10.8674 131.274 10.8284 131.367 10.718",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.931 10.7244C99.8292 10.824 99.6885 10.8609 99.5672 10.928",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1255 10.9908C95.2403 10.9302 95.3572 10.8739 95.4742 10.8176",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.6248 11.1252C76.7482 11.0385 76.876 10.9562 77.0124 10.8934",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.944 11.1641C104.072 11.1056 104.176 11.0017 104.303 10.941",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.975 11.2075C131.114 11.1403 131.233 11.0429 131.365 10.9649",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5649 11.1901C99.6905 11.1317 99.801 11.0407 99.9201 10.9692",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.119 11.2507C95.249 11.1944 95.3724 11.1186 95.4872 11.0342",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.018 11.2594C118.142 11.201 118.261 11.1338 118.371 11.0537",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M76.668 11.3352C76.798 11.2638 76.9301 11.201 77.0535 11.1208",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M121.994 11.1901C121.866 11.2572 121.734 11.32 121.613 11.3958",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.957 11.3959C104.074 11.3331 104.191 11.2638 104.314 11.2075",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.157 11.4153C118.282 11.359 118.397 11.2745 118.527 11.2247",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5715 11.4261C99.6906 11.3612 99.8054 11.2897 99.9289 11.2291",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.984 11.4391C131.103 11.3633 131.228 11.3005 131.352 11.2334",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1255 11.502C95.2424 11.4349 95.3572 11.3634 95.4742 11.2963",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M121.78 11.5366C121.918 11.4717 122.046 11.3872 122.18 11.3114",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.7178 11.5561C76.8499 11.4803 76.9799 11.4088 77.1076 11.3287",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M112.459 11.5128C112.535 11.4781 112.598 11.4175 112.676 11.3871",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.304 11.5885C118.423 11.5257 118.54 11.4564 118.655 11.3871",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.948 11.647C104.067 11.5734 104.197 11.5149 104.314 11.437",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M121.962 11.686C122.096 11.6146 122.226 11.5323 122.362 11.4695",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.975 11.6968C131.101 11.6167 131.237 11.5517 131.365 11.4716",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5649 11.6795C99.6797 11.6038 99.8032 11.5431 99.9223 11.4738",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M112.517 11.7207C112.634 11.647 112.758 11.5842 112.879 11.5128",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1255 11.751C95.2424 11.6731 95.368 11.6038 95.4893 11.5345",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.7481 11.7943C76.8737 11.7163 76.9972 11.634 77.1293 11.5669",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.334 11.8224C118.449 11.764 118.56 11.6903 118.668 11.621",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.139 11.8485C122.276 11.7856 122.397 11.6904 122.529 11.6189",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M112.717 11.8527C112.849 11.8008 112.966 11.712 113.089 11.6405",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.301 11.6882C104.195 11.7705 104.072 11.8333 103.955 11.8961",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5672 11.9178C99.6906 11.8615 99.8119 11.7965 99.9245 11.7164",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.988 11.9286C131.118 11.8658 131.25 11.8051 131.365 11.7185",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M138.652 11.8722C138.739 11.8268 138.825 11.7791 138.908 11.725",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M85.9606 11.8939C86.0473 11.855 86.1295 11.8095 86.2097 11.7575",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1342 11.9784C95.2489 11.9134 95.3659 11.8593 95.4807 11.7922",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M112.94 11.9632C113.063 11.9177 113.182 11.8441 113.299 11.7791",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.7937 11.9935C76.9193 11.9286 77.0471 11.8658 77.1705 11.7943",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.263 12.0152C122.395 11.9416 122.531 11.8744 122.666 11.803",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.276 12.065C118.391 11.9827 118.52 11.9221 118.644 11.8636",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M138.652 12.1083C138.782 12.0325 138.914 11.9568 139.048 11.8875",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M113.15 12.0975C113.273 12.039 113.384 11.9546 113.511 11.9026",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M85.9586 12.1451C86.0842 12.0607 86.2163 11.987 86.3484 11.9177",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.948 12.1473C104.061 12.0672 104.18 12.0023 104.301 11.9351",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.984 12.1863C131.111 12.1083 131.237 12.0217 131.371 11.9546",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 12.1733C99.6949 12.0953 99.8119 12.0239 99.931 11.9567",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.8282 12.2447C76.9539 12.1603 77.086 12.0867 77.2116 12.0022",
            stroke: "#02016F",
            "stroke-width": "0.0887898",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.319 12.2426C122.449 12.1668 122.57 12.0845 122.698 12.0065",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.132 12.2426C95.2532 12.1842 95.3658 12.0997 95.4806 12.0261",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.321 12.2708C113.447 12.1928 113.574 12.1192 113.698 12.0391",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M138.797 12.2816C138.931 12.2188 139.048 12.1256 139.18 12.0563",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.287 12.3076C118.421 12.2426 118.544 12.1603 118.67 12.0823",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M86.0949 12.3227C86.2292 12.2513 86.3613 12.1711 86.4912 12.091",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.95 12.3834C104.072 12.3227 104.199 12.2664 104.312 12.1841",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.988 12.418C131.12 12.353 131.254 12.2859 131.378 12.2057",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 12.405C99.6971 12.3422 99.8206 12.2902 99.9288 12.2166",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.473 12.4223C135.605 12.3573 135.733 12.2837 135.863 12.2144",
            stroke: "#02016F",
            "stroke-width": "0.0541401",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.8651 12.444C76.9972 12.3747 77.1336 12.3141 77.2636 12.2383",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M138.955 12.4332C139.083 12.3639 139.213 12.3032 139.336 12.2296",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.1887 12.2512C83.0674 12.314 82.9483 12.3768 82.8249 12.4375",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.319 12.4721C122.447 12.3942 122.581 12.3335 122.709 12.2599",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M86.253 12.4657C86.3764 12.3942 86.5042 12.3314 86.6298 12.2686",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M113.353 12.4764C113.485 12.4115 113.613 12.34 113.745 12.2707",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1255 12.4765C95.2446 12.4051 95.3724 12.3509 95.4915 12.2816",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.289 12.5479C118.408 12.4678 118.536 12.4072 118.659 12.34",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.338 12.5545C109.455 12.4722 109.581 12.4094 109.707 12.3466",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M139.072 12.6194C139.189 12.5307 139.315 12.4527 139.44 12.3812",
            stroke: "#02016F",
            "stroke-width": "0.0476433",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M86.3786 12.6411C86.4977 12.5501 86.6298 12.4787 86.7532 12.3964",
            stroke: "#02016F",
            "stroke-width": "0.0389809",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.955 12.6411C104.067 12.5696 104.178 12.5003 104.29 12.431",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.984 12.6866C131.116 12.6151 131.237 12.522 131.369 12.4549",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.9062 12.6887C77.0319 12.615 77.1488 12.5306 77.2766 12.4591",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5693 12.667C99.6949 12.6042 99.8053 12.5111 99.9331 12.4483",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 12.6844C135.605 12.6086 135.726 12.5241 135.856 12.4526",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.107 12.6779C127.235 12.6022 127.356 12.5155 127.488 12.4506",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8422 12.6974C82.9634 12.6281 83.0782 12.548 83.1995 12.4808",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.328 12.7212C122.464 12.6584 122.585 12.5652 122.715 12.4894",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.362 12.7278C113.494 12.6671 113.615 12.5762 113.741 12.5004",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.132 12.7299C95.2532 12.6801 95.3572 12.5891 95.472 12.5306",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.332 12.8013C109.462 12.7342 109.59 12.6671 109.711 12.5848",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.349 12.7884C118.46 12.7342 118.568 12.6801 118.668 12.6108",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.955 12.8685C104.078 12.81 104.206 12.745 104.321 12.6736",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.9561 12.8858C77.0773 12.8143 77.2116 12.7623 77.3307 12.6865",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.109 12.9074C127.233 12.8316 127.367 12.7753 127.491 12.7017",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.973 12.9334C131.098 12.8403 131.246 12.784 131.378 12.706",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.475 12.9183C135.596 12.8339 135.737 12.7775 135.865 12.7039",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5823 12.8923C99.6928 12.8295 99.8032 12.771 99.918 12.7147",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M82.827 12.9399C82.944 12.8641 83.0674 12.8035 83.1908 12.7407",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.371 12.9616C113.49 12.8837 113.615 12.8187 113.743 12.7581",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.328 12.9638C122.449 12.8902 122.572 12.8209 122.698 12.7581",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1342 12.9703C95.2468 12.8923 95.3702 12.8295 95.4915 12.7689",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.345 13.0482C109.464 12.9746 109.581 12.8944 109.709 12.8381",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.334 13.0503C118.443 12.9853 118.549 12.9139 118.661 12.8554",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.9821 13.1305C77.1099 13.0634 77.2312 12.9811 77.3546 12.9075",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.953 13.1261C104.08 13.0611 104.202 12.981 104.323 12.9052",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.114 13.1608C127.241 13.0872 127.371 13.0157 127.493 12.9334",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5737 13.1543C99.6971 13.0958 99.8141 13.02 99.9288 12.9442",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.994 13.1651C131.124 13.1001 131.25 13.0243 131.371 12.9442",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M135.482 13.1651C135.609 13.098 135.733 13.02 135.856 12.9442",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8292 13.1868C82.9505 13.1175 83.0783 13.0568 83.193 12.9745",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.33 13.215C122.458 13.1348 122.601 13.0764 122.72 12.9811",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M113.373 13.215C113.494 13.1457 113.62 13.085 113.737 13.0071",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1298 13.2128C95.2511 13.1565 95.368 13.0872 95.4806 13.0179",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.34 13.293C109.464 13.2237 109.589 13.1609 109.709 13.0851",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.336 13.2908C118.449 13.2258 118.568 13.1717 118.676 13.098",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.021 13.3513C77.1423 13.2755 77.2679 13.2106 77.3913 13.1391",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.961 13.3622C104.074 13.2972 104.186 13.2323 104.301 13.1716",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.105 13.4033C127.233 13.3319 127.361 13.2626 127.484 13.1868",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5629 13.4099C99.6776 13.3341 99.8054 13.2691 99.9245 13.1976",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.979 13.4207C131.109 13.3471 131.239 13.2713 131.367 13.1998",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 13.4163C135.603 13.3405 135.735 13.2734 135.858 13.1932",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8292 13.4358C82.9505 13.3644 83.0739 13.2951 83.1974 13.2258",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.328 13.4619C122.451 13.3796 122.585 13.319 122.709 13.2388",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M113.369 13.4596C113.494 13.386 113.624 13.3188 113.748 13.243",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M95.1342 13.464C95.2511 13.3947 95.3702 13.3319 95.485 13.2604",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.338 13.5397C109.46 13.4639 109.585 13.399 109.709 13.3275",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.341 13.5333C118.451 13.477 118.557 13.4099 118.666 13.3492",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M77.0622 13.581C77.19 13.5095 77.3177 13.4359 77.4412 13.3579",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.955 13.6177C104.076 13.5506 104.197 13.4813 104.316 13.4099",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5715 13.6503C99.6906 13.581 99.8097 13.5138 99.9289 13.4445",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.112 13.6545C127.237 13.5809 127.371 13.5138 127.493 13.4315",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.99 13.6611C131.12 13.5918 131.248 13.5138 131.378 13.4445",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.473 13.6633C135.603 13.5896 135.731 13.516 135.858 13.4424",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8357 13.6763C82.9461 13.6091 83.0652 13.5528 83.1735 13.4835",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.362 13.713C113.499 13.6459 113.628 13.5614 113.761 13.4856",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.328 13.7087C122.458 13.6373 122.585 13.5593 122.715 13.49",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1385 13.7066C95.2555 13.6438 95.3703 13.5788 95.4829 13.5073",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.332 13.7931C109.455 13.7173 109.585 13.6545 109.709 13.5744",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.0947 13.8083C77.2159 13.739 77.3372 13.6675 77.4607 13.6004",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.347 13.7845C118.451 13.7195 118.566 13.6697 118.666 13.5983",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.955 13.8668C104.065 13.7975 104.18 13.7369 104.292 13.6719",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.112 13.895C127.241 13.8279 127.363 13.7499 127.493 13.6806",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.578 13.8971C99.6906 13.8235 99.8119 13.7607 99.9288 13.6957",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M131.003 13.9015C131.124 13.8322 131.246 13.7564 131.371 13.6914",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 13.9058C135.596 13.8343 135.718 13.7672 135.839 13.6979",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8292 13.9297C82.9462 13.8539 83.0761 13.7889 83.1974 13.7153",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.366 13.9578C113.496 13.8906 113.622 13.8062 113.752 13.7369",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.33 13.9534C122.46 13.8841 122.585 13.804 122.715 13.7325",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1363 13.9556C95.2554 13.8884 95.3745 13.8191 95.4936 13.7477",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.1272 14.0379C77.2463 13.9664 77.3632 13.8971 77.4845 13.8322",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.336 14.0357C109.466 13.9729 109.587 13.895 109.713 13.8214",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.354 14.0227C118.458 13.9621 118.566 13.9058 118.672 13.843",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.957 14.1116C104.074 14.0466 104.191 13.9816 104.306 13.9145",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.109 14.1418C127.237 14.0681 127.367 14.0053 127.491 13.9274",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.988 14.1462C131.12 14.0834 131.25 14.0054 131.378 13.9318",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 14.1462C135.603 14.0791 135.726 14.0141 135.848 13.9383",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5801 14.1353C99.6992 14.0747 99.814 14.0097 99.9288 13.9404",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8249 14.1656C82.944 14.1006 83.0674 14.0357 83.1887 13.9664",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.328 14.1982C122.455 14.1224 122.592 14.0509 122.72 13.9751",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.362 14.2025C113.488 14.1245 113.622 14.0574 113.752 13.9859",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1342 14.2068C95.2489 14.131 95.3724 14.0747 95.4893 14.0032",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.1359 14.2762C77.2593 14.2069 77.3806 14.1267 77.5062 14.0618",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.338 14.2826C109.455 14.2112 109.57 14.144 109.689 14.0769",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.349 14.2718C118.458 14.2111 118.564 14.144 118.674 14.0855",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.966 14.3583C104.082 14.2891 104.197 14.2198 104.314 14.1505",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.114 14.3866C127.246 14.3194 127.371 14.2436 127.495 14.1635",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.988 14.3974C131.122 14.3324 131.252 14.2544 131.378 14.17",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 14.3844C99.7014 14.3194 99.8141 14.2501 99.931 14.1808",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 14.3974C135.607 14.3346 135.728 14.2588 135.85 14.1808",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.193 14.2089C83.0761 14.2912 82.9461 14.3519 82.8227 14.4212",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.743 14.235C113.624 14.3086 113.501 14.3736 113.377 14.4386",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.33 14.4407C122.458 14.3757 122.588 14.3021 122.713 14.2263",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1342 14.4428C95.2489 14.3887 95.3637 14.3237 95.4742 14.2587",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M77.1509 14.4992C77.27 14.4364 77.387 14.3714 77.5061 14.3108",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.338 14.5165C109.462 14.4472 109.587 14.3866 109.711 14.3151",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.339 14.5186C118.445 14.4493 118.568 14.3995 118.674 14.3324",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.95 14.6053C104.069 14.5339 104.191 14.4624 104.314 14.3996",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.114 14.6378C127.237 14.5598 127.365 14.4884 127.497 14.4234",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5845 14.6183C99.6992 14.5533 99.814 14.4883 99.9288 14.4212",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.99 14.6464C131.116 14.5728 131.239 14.4948 131.371 14.4299",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.473 14.6421C135.601 14.5728 135.724 14.4905 135.856 14.4277",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8183 14.6811C82.9309 14.5901 83.0673 14.5317 83.1908 14.4559",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.375 14.6941C113.494 14.6031 113.631 14.5468 113.752 14.4623",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.332 14.6941C122.455 14.6053 122.59 14.536 122.72 14.4623",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1276 14.7006C95.2359 14.6313 95.3528 14.5663 95.4611 14.4949",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.5126 14.5359C77.3935 14.6009 77.2831 14.6832 77.1575 14.7438",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.351 14.7699C109.47 14.6984 109.596 14.6313 109.711 14.549",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.345 14.7742C118.456 14.7049 118.57 14.6421 118.679 14.5706",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.321 14.6378C104.208 14.7114 104.089 14.7851 103.963 14.8435",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.112 14.8825C127.241 14.8175 127.369 14.7482 127.49 14.6702",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5888 14.8695C99.7057 14.8067 99.827 14.7439 99.9375 14.6681",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.992 14.889C131.12 14.8197 131.246 14.7547 131.369 14.6789",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.488 14.8824C135.614 14.8196 135.737 14.7503 135.854 14.6767",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M82.84 14.8998C82.9548 14.8327 83.0782 14.7807 83.1887 14.7049",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.373 14.9301C113.499 14.8587 113.633 14.8067 113.75 14.7222",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.341 14.9279C122.466 14.8565 122.594 14.798 122.717 14.72",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.106 14.9431C95.2208 14.8911 95.3269 14.8262 95.4374 14.7677",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.4866 14.811C77.3762 14.8673 77.2679 14.9258 77.1596 14.9843",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.347 15.0038C109.457 14.928 109.585 14.8868 109.696 14.811",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.345 15.0038C118.449 14.9323 118.57 14.8911 118.674 14.8218",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.966 15.0817C104.078 15.0124 104.191 14.9452 104.308 14.8889",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.114 15.1358C127.231 15.0449 127.363 14.9756 127.493 14.9084",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5629 15.1467C99.6711 15.0514 99.7989 14.9821 99.9289 14.9171",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.984 15.1554C131.105 15.0644 131.237 14.9908 131.369 14.9193",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 15.1467C135.598 15.0601 135.724 14.9799 135.856 14.915",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8357 15.1662C82.9526 15.0882 83.0696 15.0016 83.1995 14.9431",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M113.373 15.19C113.496 15.112 113.618 15.0362 113.741 14.9583",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.334 15.1856C122.464 15.1163 122.577 15.0189 122.711 14.9539",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.0562 15.229C95.1645 15.1683 95.2771 15.1077 95.3681 15.0211",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.138 15.2549C77.2593 15.1943 77.3805 15.1271 77.4823 15.0383",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.704 15.0383C109.6 15.1271 109.479 15.1921 109.358 15.2549",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.358 15.255C118.466 15.1922 118.592 15.1424 118.679 15.0493",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.968 15.3286C104.082 15.2636 104.225 15.2225 104.321 15.125",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5888 15.3481C99.7014 15.2874 99.8227 15.2441 99.9288 15.1705",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.124 15.3611C127.248 15.2896 127.391 15.2442 127.503 15.1575",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.988 15.3698C131.12 15.3135 131.248 15.2463 131.373 15.1792",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 15.3654C135.607 15.3069 135.735 15.2484 135.856 15.1748",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8292 15.3849C82.9483 15.3177 83.0783 15.2744 83.193 15.2008",
            stroke: "#02016F",
            "stroke-width": "0.0563057",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.373 15.4066C113.499 15.3373 113.635 15.2832 113.761 15.2117",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.33 15.4153C122.458 15.3373 122.598 15.2875 122.724 15.2117",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.34 15.5062C109.455 15.4196 109.583 15.3589 109.713 15.2983",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.345 15.4997C118.445 15.4239 118.553 15.3676 118.668 15.3177",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.0969 15.5321C77.1857 15.4433 77.3026 15.3892 77.413 15.3307",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.9955 15.5083C95.054 15.4412 95.1493 15.4152 95.2121 15.3502",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.955 15.5927C104.067 15.5213 104.171 15.439 104.29 15.374",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5715 15.634C99.695 15.556 99.8076 15.4607 99.9397 15.3958",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.109 15.6275C127.248 15.5603 127.361 15.4542 127.497 15.3871",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M130.988 15.6405C131.12 15.569 131.237 15.4672 131.369 15.3958",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 15.6361C135.614 15.569 135.724 15.4629 135.858 15.3979",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.827 15.6555C82.9591 15.5884 83.0761 15.4996 83.1973 15.4195",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.392 15.6729C113.522 15.6079 113.641 15.5213 113.761 15.439",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.343 15.6751C122.475 15.6101 122.594 15.517 122.72 15.439",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.343 15.7444C109.468 15.6967 109.592 15.6274 109.707 15.5473",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.343 15.7443C118.458 15.6945 118.581 15.6382 118.683 15.5581",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.955 15.8202C104.078 15.7617 104.204 15.7033 104.323 15.6296",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M77.0405 15.8007C77.112 15.7314 77.2289 15.7227 77.2961 15.6448",
            stroke: "#02016F",
            "stroke-width": "0.0541401",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5715 15.8527C99.6863 15.7834 99.8119 15.7293 99.9289 15.6686",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.124 15.844C127.241 15.7747 127.373 15.7249 127.493 15.6556",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.986 15.8592C131.113 15.7899 131.246 15.7293 131.373 15.6643",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 15.857C135.603 15.7833 135.739 15.7292 135.865 15.6556",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8292 15.8743C82.9483 15.8137 83.0674 15.7487 83.1887 15.6924",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.332 15.9089C122.453 15.8223 122.588 15.766 122.72 15.701",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.373 15.9177C113.483 15.8311 113.615 15.7812 113.739 15.7141",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.338 16.0043C109.462 15.9263 109.577 15.8419 109.711 15.7834",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.347 15.9978C118.453 15.9263 118.56 15.8548 118.676 15.7985",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.961 16.0736C104.085 16.0173 104.195 15.935 104.312 15.8614",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M127.12 16.106C127.25 16.0411 127.378 15.9631 127.499 15.8765",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.994 16.119C131.122 16.0432 131.256 15.9761 131.373 15.8851",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5759 16.1017C99.6993 16.0454 99.8119 15.9674 99.9289 15.8938",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 16.1233C135.609 16.054 135.733 15.9761 135.856 15.8959",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8314 16.1386C82.9548 16.0693 83.0869 16.0108 83.1973 15.9177",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.334 16.1537C122.468 16.0952 122.598 16.0151 122.722 15.9306",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.373 16.1559C113.507 16.0996 113.633 16.0216 113.756 15.9415",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.349 16.2316C109.468 16.1645 109.59 16.1082 109.707 16.0367",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.341 16.2339C118.453 16.1732 118.577 16.1169 118.683 16.0455",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.961 16.3161C104.072 16.2425 104.195 16.1862 104.312 16.119",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M127.118 16.3551C127.241 16.2793 127.371 16.21 127.499 16.1407",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.99 16.3724C131.107 16.2901 131.239 16.2187 131.367 16.1516",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.479 16.3638C135.605 16.288 135.731 16.2165 135.856 16.1451",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.931 16.1493C99.8076 16.1991 99.6993 16.2792 99.5823 16.342",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8378 16.3789C82.9526 16.301 83.0825 16.2446 83.1973 16.1667",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M76.9149 16.3464C77.0124 16.2879 77.112 16.2338 77.2116 16.1775",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.332 16.407C122.46 16.3356 122.581 16.2511 122.715 16.1883",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.373 16.4092C113.499 16.3334 113.622 16.2554 113.754 16.1883",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.349 16.4807C109.475 16.4179 109.592 16.3399 109.715 16.2706",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.349 16.485C118.462 16.42 118.581 16.3637 118.683 16.2858",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.966 16.5565C104.085 16.4958 104.199 16.433 104.314 16.3616",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.118 16.5955C127.248 16.5219 127.387 16.4612 127.508 16.3724",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5759 16.5954C99.695 16.5283 99.8184 16.4633 99.9354 16.3918",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 16.6062C135.603 16.5326 135.735 16.4655 135.861 16.3875",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M130.986 16.6127C131.111 16.5369 131.246 16.4763 131.369 16.3962",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8336 16.6171C82.9548 16.5565 83.0739 16.4893 83.193 16.4244",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M113.362 16.667C113.483 16.5803 113.622 16.5197 113.75 16.4482",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.334 16.6495C122.462 16.5759 122.592 16.5088 122.72 16.4373",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.347 16.7384C109.46 16.6582 109.585 16.5933 109.707 16.5261",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.349 16.7297C118.458 16.6604 118.572 16.6019 118.683 16.5348",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.959 16.812C104.074 16.7471 104.186 16.6778 104.301 16.6085",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.124 16.8424C127.252 16.7709 127.378 16.6973 127.501 16.6215",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M131.131 16.7774C131.213 16.7319 131.291 16.6821 131.369 16.6323",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 16.8401C99.7036 16.7795 99.8141 16.7037 99.931 16.6344",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 16.8596C135.609 16.7903 135.735 16.7124 135.863 16.6344",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8378 16.8705C82.9656 16.812 83.0847 16.7319 83.2038 16.6626",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M113.498 16.8251C113.589 16.7947 113.667 16.7319 113.752 16.6865",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.354 16.8856C122.479 16.8228 122.601 16.7514 122.72 16.6777",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.349 16.9701C109.47 16.8986 109.598 16.8423 109.72 16.7687",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.343 16.9701C118.453 16.9094 118.57 16.8553 118.676 16.7881",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.959 17.0503C104.078 16.9788 104.202 16.9138 104.323 16.8489",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M127.112 17.0958C127.239 17.02 127.369 16.9398 127.506 16.8749",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5759 17.0849C99.6885 17.0092 99.8097 16.9507 99.9289 16.8835",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.477 17.0979C135.605 17.0264 135.728 16.9485 135.861 16.8857",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8422 17.1152C82.9591 17.0416 83.0804 16.9809 83.1973 16.9073",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.33 17.1541C122.46 17.0784 122.583 16.9896 122.72 16.9268",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.347 17.2278C109.479 17.1629 109.603 17.0784 109.728 17.0026",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.347 17.2279C118.46 17.1716 118.564 17.0979 118.672 17.033",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M103.966 17.2949C104.085 17.2386 104.199 17.1737 104.31 17.1",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.133 17.3384C127.259 17.2561 127.406 17.2041 127.523 17.111",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 17.3275C99.7036 17.2604 99.8314 17.2041 99.9397 17.1218",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.492 17.3361C135.609 17.2625 135.739 17.2083 135.856 17.1304",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8357 17.3556C82.957 17.2928 83.0804 17.2365 83.1952 17.1628",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.347 17.3772C122.475 17.31 122.6 17.2407 122.726 17.1758",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.373 17.4531C109.494 17.3773 109.624 17.3123 109.75 17.2408",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.347 17.4617C118.453 17.4054 118.56 17.3361 118.672 17.2841",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.155 17.5635C127.291 17.492 127.417 17.4033 127.555 17.3361",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.966 17.544C104.082 17.4704 104.202 17.4033 104.321 17.3361",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.492 17.5916C135.624 17.5158 135.754 17.4292 135.889 17.3577",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5801 17.5744C99.7036 17.5094 99.8184 17.4293 99.9418 17.3665",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.8508 17.6112C82.9721 17.5354 83.0955 17.4639 83.219 17.3946",
            stroke: "#02016F",
            "stroke-width": "0.0844586",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.73 17.4032C122.601 17.479 122.473 17.5613 122.341 17.6349",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.412 17.687C109.544 17.6112 109.683 17.5311 109.813 17.4488",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.358 17.7129C118.464 17.6479 118.572 17.5916 118.676 17.5267",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M127.228 17.7757C127.367 17.6999 127.503 17.6263 127.64 17.544",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.54 17.7995C135.681 17.7346 135.815 17.6501 135.952 17.5765",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.959 17.7952C104.085 17.7281 104.21 17.6631 104.331 17.5851",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M82.9028 17.8169C83.0327 17.7584 83.1561 17.6783 83.2839 17.6133",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5823 17.8169C99.7036 17.7563 99.8206 17.687 99.9397 17.622",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.518 17.8601C109.652 17.7887 109.787 17.7172 109.919 17.6458",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.343 17.8666C122.473 17.7973 122.605 17.7324 122.73 17.6566",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.358 17.9252C127.488 17.8602 127.616 17.7823 127.748 17.7216",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.666 17.9642C135.787 17.8927 135.913 17.8256 136.038 17.7606",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.0198 17.9923C83.1367 17.9143 83.2645 17.8537 83.3858 17.7844",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.347 17.9468C118.458 17.884 118.573 17.8255 118.681 17.7649",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M103.974 18.027C104.098 17.9469 104.225 17.8732 104.355 17.8061",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M109.687 18.0053C109.813 17.9316 109.94 17.8602 110.07 17.793",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.9288 17.8602C99.8097 17.923 99.6992 17.9988 99.5801 18.066",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M127.555 18.0768C127.677 18.001 127.8 17.9295 127.924 17.8559",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.36 18.12C122.492 18.0464 122.618 17.9641 122.748 17.8883",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M135.826 18.1308C135.96 18.0594 136.084 17.9706 136.218 17.8991",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.5655 17.9251C83.4334 17.9944 83.3121 18.094 83.1735 18.1482",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M109.873 18.1482C110.001 18.0854 110.118 18.0009 110.244 17.9316",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.735 18.2067C127.872 18.1548 127.991 18.0616 128.121 17.9945",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.345 18.2045C118.46 18.1482 118.57 18.0854 118.676 18.0161",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.026 18.237C104.152 18.1698 104.277 18.1027 104.399 18.0269",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M136.025 18.2543C136.151 18.1872 136.276 18.1201 136.395 18.0464",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.3749 18.2673C83.5005 18.2197 83.6175 18.1417 83.7366 18.0767",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M110.096 18.2608C110.22 18.2088 110.335 18.133 110.454 18.0724",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.404 18.3258C122.538 18.25 122.674 18.1786 122.811 18.1049",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M99.5845 18.3085C99.7036 18.2414 99.827 18.1807 99.944 18.1093",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M127.999 18.3323C128.116 18.2717 128.231 18.2024 128.348 18.1483",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M110.298 18.3908C110.419 18.3345 110.536 18.2565 110.657 18.1959",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M136.268 18.3951C136.385 18.3301 136.499 18.2543 136.623 18.2002",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.5937 18.4103C83.702 18.3453 83.8146 18.2825 83.9229 18.2175",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.085 18.4557C104.219 18.3821 104.345 18.2911 104.485 18.2283",
            stroke: "#02016F",
            "stroke-width": "0.0563057",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M118.349 18.4492C118.46 18.3821 118.572 18.3171 118.683 18.25",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M128.209 18.4644C128.322 18.3994 128.432 18.328 128.547 18.2673",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M78.0865 18.3886C78.1558 18.3627 78.2164 18.3085 78.2857 18.2825",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M110.508 18.5207C110.631 18.4622 110.75 18.3886 110.867 18.3149",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M78.3767 18.473C78.472 18.4362 78.5521 18.3452 78.6539 18.3301",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M83.7756 18.5424C83.9012 18.4839 84.0139 18.406 84.133 18.3367",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.531 18.5467C122.65 18.4774 122.772 18.4103 122.889 18.3367",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M136.467 18.5272C136.582 18.4687 136.69 18.395 136.803 18.3344",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 18.5532C99.7058 18.4947 99.8227 18.4189 99.9397 18.3475",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M94.1337 18.4557C94.203 18.421 94.2679 18.3799 94.3372 18.3409",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.3914 18.5466C94.4975 18.5033 94.5863 18.4167 94.6967 18.3907",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M128.409 18.59C128.524 18.5315 128.634 18.4622 128.747 18.4016",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M78.6345 18.5727C78.7341 18.5186 78.8359 18.4644 78.9355 18.4059",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.197 18.6398C104.321 18.5662 104.448 18.5033 104.568 18.4276",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M111.075 18.4536C110.956 18.5185 110.837 18.5965 110.716 18.6463",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M136.671 18.6464C136.777 18.5901 136.883 18.5316 136.989 18.4709",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M83.9749 18.6679C84.094 18.6116 84.2087 18.5423 84.3257 18.4774",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.6188 18.6527C94.7314 18.6029 94.8332 18.5293 94.9458 18.4795",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.345 18.6896C118.456 18.6225 118.579 18.5727 118.685 18.499",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M78.851 18.6896C78.9658 18.6377 79.0697 18.5662 79.1824 18.5099",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M122.635 18.7265C122.75 18.6507 122.876 18.5944 122.995 18.5208",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M128.608 18.7308C128.727 18.6702 128.838 18.5922 128.961 18.5359",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M110.919 18.7718C111.049 18.7307 111.162 18.6354 111.287 18.5791",
            stroke: "#02016F",
            "stroke-width": "0.082293",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.8072 18.8066C94.9285 18.7329 95.0541 18.6658 95.1775 18.5922",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5801 18.8001C99.7014 18.7308 99.8205 18.6658 99.9375 18.5944",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.325 18.8044C104.453 18.7351 104.576 18.6593 104.706 18.5922",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M137.212 18.5922C137.091 18.655 136.98 18.7394 136.857 18.7871",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M84.1633 18.8087C84.2889 18.7589 84.408 18.6679 84.5336 18.6073",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M79.0459 18.8261C79.1758 18.7611 79.2949 18.6745 79.4292 18.6204",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M128.809 18.8585C128.931 18.8043 129.037 18.7156 129.158 18.6679",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M123.12 18.6853C123.008 18.7503 122.893 18.8152 122.78 18.8759",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M111.14 18.9062C111.257 18.8369 111.376 18.7697 111.497 18.7048",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M137.407 18.7286C137.288 18.7828 137.175 18.8694 137.056 18.9192",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M84.3776 18.9386C84.4967 18.8737 84.6137 18.7979 84.7349 18.7372",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M94.9955 18.9495C95.1211 18.8845 95.2424 18.8065 95.3659 18.7372",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.513 18.9451C104.635 18.8758 104.758 18.8022 104.882 18.7372",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.358 18.9365C118.462 18.8715 118.572 18.8174 118.674 18.7502",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M79.2451 18.9625C79.3599 18.8932 79.479 18.8283 79.5959 18.7633",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M129.006 18.9928C129.121 18.93 129.236 18.8628 129.346 18.7914",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M111.37 19.0253C111.48 18.9603 111.588 18.8867 111.705 18.8304",
            stroke: "#02016F",
            "stroke-width": "0.071465",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M122.973 19.0209C123.081 18.9559 123.19 18.8888 123.3 18.826",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5888 19.0513C99.7079 18.9841 99.8227 18.9062 99.944 18.8434",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M137.259 19.0556C137.379 18.9971 137.491 18.9192 137.608 18.8585",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M84.9472 18.8694C84.8194 18.9192 84.7003 19.0318 84.566 19.0708",
            stroke: "#02016F",
            "stroke-width": "0.0866242",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.717 19.0816C104.84 19.0167 104.959 18.9452 105.079 18.8716",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.1212 19.1249C95.2489 19.0556 95.3767 18.9841 95.5001 18.9105",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M79.3945 19.1293C79.5201 19.06 79.6414 18.9907 79.7648 18.9214",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M129.164 19.1141C129.297 19.0621 129.407 18.9669 129.537 18.9171",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M111.541 19.1509C111.669 19.0989 111.788 19.0253 111.905 18.9538",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M123.17 19.1466C123.287 19.099 123.397 19.0232 123.51 18.9669",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.685 19.0015C118.577 19.0643 118.466 19.1249 118.354 19.1769",
            stroke: "#02016F",
            "stroke-width": "0.0606369",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M137.474 19.1747C137.589 19.1184 137.699 19.0577 137.81 18.9949",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M84.7739 19.2007C84.8974 19.1422 85.0186 19.0642 85.1421 19.0079",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M104.921 19.2006C105.035 19.1378 105.15 19.0794 105.265 19.0144",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M129.355 19.2418C129.481 19.1833 129.602 19.1097 129.725 19.0447",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M79.5201 19.3133C79.6501 19.2332 79.7865 19.1661 79.9164 19.0859",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.2402 19.3133C95.3637 19.2288 95.5001 19.1682 95.6279 19.0902",
            stroke: "#02016F",
            "stroke-width": "0.0671338",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.5823 19.2959C99.6928 19.2202 99.8119 19.1617 99.931 19.0989",
            stroke: "#02016F",
            "stroke-width": "0.0628025",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M111.766 19.2765C111.887 19.2115 112.009 19.1336 112.134 19.0859",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M123.393 19.27C123.501 19.2072 123.61 19.1508 123.72 19.0902",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M137.66 19.3133C137.773 19.2484 137.883 19.1769 138.002 19.1206",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M84.9775 19.335C85.0901 19.2635 85.207 19.1985 85.3261 19.1357",
            stroke: "#02016F",
            "stroke-width": "0.0736306",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M105.105 19.3609C105.228 19.2873 105.345 19.2029 105.475 19.1465",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M129.578 19.3783C129.697 19.3047 129.814 19.231 129.935 19.1661",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M111.983 19.4108C112.102 19.348 112.212 19.2679 112.331 19.2051",
            stroke: "#02016F",
            "stroke-width": "0.0801274",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M123.61 19.4C123.722 19.3415 123.824 19.2614 123.937 19.2051",
            stroke: "#02016F",
            "stroke-width": "0.0692994",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M118.352 19.4346C118.464 19.3739 118.575 19.3025 118.681 19.2375",
            stroke: "#02016F",
            "stroke-width": "0.0649682",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M138.208 19.2505C138.089 19.3241 137.974 19.4042 137.846 19.4606",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M79.6328 19.4931C79.7649 19.426 79.8861 19.3372 80.0096 19.2549",
            stroke: "#02016F",
            "stroke-width": "0.0584713",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M85.168 19.48C85.2958 19.4129 85.4149 19.3392 85.5362 19.2634",
            stroke: "#02016F",
            "stroke-width": "0.0757962",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M95.3226 19.4953C95.4547 19.4238 95.5803 19.3437 95.7037 19.2592",
            stroke: "#02016F",
            "stroke-width": "0.0324841",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M129.821 19.5081C129.933 19.4475 130.048 19.389 130.152 19.3132",
            stroke: "#02016F",
            "stroke-width": "0.0519745",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M99.6365 19.5039C99.7469 19.4541 99.8465 19.3913 99.9505 19.3306",
            stroke: "#02016F",
            "stroke-width": "0.0541401",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M112.162 19.5191C112.284 19.4693 112.392 19.3935 112.505 19.3285",
            stroke: "#02016F",
            "stroke-width": "0.0281529",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M121.448 11.2486C121.583 11.1923 121.697 11.1013 121.823 11.032",
            stroke: "#02016F",
            "stroke-width": "0.0779618",
            "stroke-miterlimit": "7.25",
            "stroke-linecap": "round"
          }
        })
      ]),
      _vm._v(" "),
      _c("g", { attrs: { "clip-path": "url(#clip2_778_1196)" } }, [
        _c("path", {
          attrs: {
            d:
              "M172.127 8.73035V11.3423H167.674V8.73035H166.003V15.2616H167.674V12.6496H172.127V15.2616H173.797V8.73035H172.127Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M182.297 15.2616H184.181L180.572 8.73035H178.677L175.068 15.2616H176.951L177.545 14.0358H181.707L182.3 15.2616H182.297ZM178.106 12.8698L179.604 9.8746H179.639L181.137 12.8698H178.104H178.106Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M199.105 15.2616H200.989L197.379 8.73035H195.484L191.875 15.2616H193.759L194.352 14.0358H198.514L199.108 15.2616H199.105ZM194.914 12.8698L196.412 9.8746H196.446L197.944 12.8698H194.911H194.914Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M190.536 8.73035C190.219 10.5024 189.435 12.3561 188.11 14.1363H188.009L185.244 8.73035H183.314L186.892 15.2616H188.917C190.749 13.1497 191.918 10.8775 192.301 8.73035H190.536Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M203.538 10.5323C203.538 10.2008 203.958 9.85829 205.306 9.85829C206.11 9.85829 206.983 9.99691 207.858 10.2334L208.072 9.01301C207.305 8.75209 206.219 8.6026 205.286 8.6026C202.904 8.6026 201.948 9.58106 201.948 10.6248C201.948 13.0546 206.986 12.2555 206.986 13.3971C206.986 13.851 206.317 14.1499 205.128 14.1499C204.114 14.1499 203.063 13.9298 202.187 13.5357L201.988 14.805C202.838 15.1719 203.93 15.3893 205.073 15.3893C207.205 15.3893 208.573 14.5413 208.573 13.2802C208.573 10.7905 203.535 11.6684 203.535 10.5351L203.538 10.5323Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M263.837 14.0086V15.2616H257.258V8.73035H263.641V10.0023H258.92V11.3695H262.944V12.4594H258.92V14.0086H263.84H263.837Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M237.501 8.73035C236.942 9.77404 236.104 10.8612 235.05 11.9185H235.007L232.426 8.73035H230.487L234.03 13.0247V15.2616H235.718V13.0247C237.345 11.6358 238.61 10.1437 239.365 8.73035H237.501Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M255.253 14.8457C254.605 15.142 253.427 15.4002 252.41 15.4002C249.227 15.4002 247.816 14.1037 247.816 12.0136C247.816 9.9235 249.233 8.59985 252.41 8.59985C253.352 8.59985 254.357 8.73032 255.095 8.95591L254.928 10.2279C254.216 10.0105 253.358 9.88001 252.491 9.88001C250.587 9.88001 249.567 10.5812 249.567 11.9864C249.567 13.3916 250.322 14.1119 252.353 14.1119C252.906 14.1119 253.387 14.0521 253.801 13.9379V11.8641H255.25V14.843L255.253 14.8457Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M245.405 15.2616H247.289L243.68 8.73035H241.784L238.175 15.2616H240.059L240.652 14.0358H244.814L245.408 15.2616H245.405ZM241.214 12.8698L242.712 9.8746H242.746L244.244 12.8698H241.211H241.214Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M219.32 8.73035C219.003 10.5024 218.219 12.3561 216.894 14.1363H216.794L214.028 8.73035H212.098L215.676 15.2616H217.701C219.533 13.1497 220.702 10.8775 221.085 8.73035H219.32Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M266.959 10.5323C266.959 10.2008 267.38 9.85829 268.728 9.85829C269.531 9.85829 270.404 9.99691 271.28 10.2334L271.493 9.01301C270.727 8.75209 269.641 8.6026 268.708 8.6026C266.326 8.6026 265.369 9.58106 265.369 10.6248C265.369 13.0546 270.407 12.2555 270.407 13.3971C270.407 13.851 269.739 14.1499 268.549 14.1499C267.535 14.1499 266.484 13.9298 265.608 13.5357L265.41 14.805C266.259 15.1719 267.351 15.3893 268.495 15.3893C270.626 15.3893 271.994 14.5413 271.994 13.2802C271.994 10.7905 266.956 11.6684 266.956 10.5351L266.959 10.5323Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M226.143 15.3839C223.107 15.3839 221.918 14.0004 221.918 11.9864C221.918 9.97244 223.107 8.60803 226.143 8.60803C229.179 8.60803 230.343 9.97516 230.343 11.9864C230.343 13.9977 229.171 15.3839 226.143 15.3839ZM226.143 9.88003C224.343 9.88003 223.669 10.5242 223.669 11.9783C223.669 13.4324 224.343 14.1037 226.143 14.1037C227.944 14.1037 228.598 13.4324 228.598 11.9783C228.598 10.5242 227.961 9.88003 226.143 9.88003Z",
            fill: "#02016F"
          }
        })
      ]),
      _vm._v(" "),
      _c("g", { attrs: { "clip-path": "url(#clip3_778_1196)" } }, [
        _c("path", {
          attrs: {
            d:
              "M320.32 16.5757V13.4951H321.387C322.076 13.4951 322.505 13.8511 322.505 14.5141C322.505 15.177 321.974 15.539 321.387 15.539H320.829V16.5757H320.32ZM321.321 13.9888H320.829V15.0413H321.321C321.806 15.0413 322.002 14.8387 322.002 14.5141C322.002 14.1895 321.772 13.9908 321.321 13.9908V13.9888ZM323.001 13.4951H323.51V14.7836H324.902V13.4951H325.408V16.5757H324.904V15.2813H323.513V16.5757H323.003V13.4951H323.001ZM326.433 12.4859C326.607 12.4859 326.746 12.6256 326.746 12.7947C326.746 12.9639 326.603 13.0996 326.429 13.0996C326.256 13.0996 326.117 12.96 326.117 12.7908C326.119 12.6216 326.26 12.4878 326.433 12.4878V12.4859ZM326.178 16.5757H326.687V13.4951H326.178V16.5757ZM327.459 13.4951H327.968V16.078H329.336V16.5757H327.459V13.4951ZM329.836 13.4951H330.345V14.7836H331.737V13.4951H332.243V16.5757H331.737V15.2813H330.345V16.5757H329.836V13.4951ZM334.02 13.4065L335.371 16.5757H334.835L334.638 16.1351H333.389L333.216 16.5757H332.67L334.02 13.4065ZM333.619 15.6374H334.426L334.022 14.7128L333.621 15.6374H333.619ZM335.732 16.5757V13.4951H336.906C337.474 13.4951 337.921 13.861 337.921 14.4551C337.921 14.8682 337.71 15.2065 337.303 15.3442L338.012 16.5757H337.44L336.785 15.4328H336.239V16.5757H335.73H335.732ZM336.803 13.9888H336.239V14.9351H336.803C337.196 14.9351 337.416 14.76 337.416 14.4551C337.416 14.1501 337.194 13.9888 336.803 13.9888ZM339.108 13.4124L340.073 15.4367L341.022 13.4065L341.787 16.5757H341.273L340.887 14.878L340.071 16.6642L339.233 14.878L338.836 16.5757H338.322L339.108 13.4124ZM342.079 15.0354C342.079 14.16 342.754 13.4419 343.58 13.4419C344.406 13.4419 345.081 14.16 345.081 15.0354C345.081 15.9108 344.406 16.6288 343.58 16.6288C342.754 16.6288 342.079 15.9108 342.079 15.0354ZM343.58 13.9219C343.026 13.9219 342.575 14.4236 342.575 15.0354C342.575 15.6472 343.026 16.1449 343.58 16.1449C344.134 16.1449 344.589 15.6472 344.589 15.0354C344.589 14.4236 344.134 13.9219 343.58 13.9219ZM345.576 13.4065L347.419 15.3659V13.497H347.929V16.6662L346.086 14.7344V16.5757H345.576V13.4065ZM348.956 12.4859C349.129 12.4859 349.268 12.6256 349.268 12.7947C349.268 12.9639 349.125 13.0996 348.952 13.0996C348.779 13.0996 348.64 12.96 348.64 12.7908C348.642 12.6216 348.783 12.4878 348.956 12.4878V12.4859ZM348.7 16.5757H349.21V13.4951H348.7V16.5757ZM349.98 13.4951H351.867V13.9888H350.487V14.7718H351.722V15.2695H350.487V16.08H351.911V16.5777H349.978V13.497L349.98 13.4951ZM327.1 21.0413V17.9606H328.109C328.917 17.9606 329.642 18.3974 329.642 19.501C329.642 20.7895 328.808 21.0413 328.156 21.0413H327.102H327.1ZM328.063 18.4544H327.608V20.5456H328.107C328.774 20.5456 329.135 20.2288 329.135 19.5029C329.137 18.84 328.724 18.4564 328.061 18.4564L328.063 18.4544ZM330.136 17.9606H332.023V18.4544H330.643V19.2354H331.878V19.7331H330.643V20.5436H332.068V21.0413H330.136V17.9626V17.9606ZM333.804 21.0413V17.9606H334.872C335.561 17.9606 335.99 18.3167 335.99 18.9797C335.99 19.6426 335.458 20.0046 334.872 20.0046H334.314V21.0433H333.804V21.0413ZM334.805 18.4544H334.314V19.5069H334.805C335.293 19.5069 335.486 19.3042 335.486 18.9797C335.486 18.6551 335.256 18.4564 334.805 18.4564V18.4544ZM337.184 17.8741L338.536 21.0433H338L337.803 20.6026H336.554L336.38 21.0433H335.835L337.184 17.8741ZM336.783 20.1049H337.591L337.186 19.1803L336.785 20.1049H336.783ZM338.888 21.0413V17.9606H340.065C340.633 17.9606 341.08 18.3265 341.08 18.9226C341.08 19.3357 340.868 19.6741 340.462 19.8118L341.169 21.0433H340.597L339.942 19.8964H339.398V21.0393H338.888V21.0413ZM339.96 18.4544H339.398V19.4006H339.962C340.355 19.4006 340.574 19.2256 340.574 18.9206C340.574 18.6157 340.353 18.4544 339.96 18.4544ZM342.033 16.9515C342.206 16.9534 342.345 17.0931 342.343 17.2623C342.341 17.4315 342.198 17.5672 342.025 17.5652C341.852 17.5633 341.713 17.4236 341.715 17.2544C341.717 17.0852 341.86 16.9495 342.033 16.9515ZM341.777 21.0413H342.287V17.9606H341.777V21.0413ZM344.011 17.9075C344.404 17.9075 344.768 18.057 344.996 18.3344L344.656 18.6688C344.498 18.4701 344.233 18.3993 344.011 18.3993C343.731 18.3993 343.493 18.4918 343.483 18.72C343.465 19.3141 345.111 19.0033 345.111 20.1915C345.111 20.7777 344.571 21.0885 344.009 21.0885C343.481 21.0885 343.108 20.8996 342.873 20.5613L343.288 20.2446C343.485 20.4472 343.681 20.5928 344.009 20.5928C344.38 20.5928 344.603 20.4334 344.603 20.1836C344.603 19.5108 342.972 19.8177 342.972 18.7357C342.972 18.2419 343.407 17.9075 344.009 17.9075H344.011ZM321.45 8.83276C321.794 8.83276 321.982 8.94686 322.125 9.06686V9.33834C321.951 9.17703 321.762 9.04719 321.45 9.05506C320.926 9.06489 320.503 9.49965 320.503 10.0288C320.503 10.558 320.98 10.9987 321.452 10.9987C321.722 11.0105 321.984 10.9042 322.161 10.7056V10.9888C322.016 11.1246 321.752 11.2269 321.452 11.2269C320.763 11.2249 320.271 10.6465 320.271 10.0288C320.271 9.41113 320.785 8.83473 321.452 8.83473L321.45 8.83276ZM322.751 8.22489C322.85 8.22489 322.93 8.29965 322.932 8.39407C322.932 8.49047 322.856 8.56916 322.759 8.57112C322.662 8.57309 322.58 8.49637 322.578 8.40194C322.576 8.30752 322.65 8.2308 322.747 8.22686C322.747 8.22686 322.751 8.22686 322.753 8.22686L322.751 8.22489ZM322.634 11.1816H322.866V8.87014H322.634V11.1816ZM323.287 8.87014H324.993V9.09244H324.254V11.1816H324.026V9.09244H323.287V8.87014ZM325.366 8.87014H326.782V9.09244H325.595V9.90489H326.673V10.1272H325.595V10.9593H326.812V11.1856H325.364V8.87407L325.366 8.87014ZM325.64 8.64391V8.50227L326.621 8.21899V8.43342L325.64 8.64391ZM328.117 11.1816V8.87014H328.875C329.479 8.87014 330.023 9.1967 330.023 10.0249C330.023 10.9928 329.399 11.1796 328.907 11.1796H328.115L328.117 11.1816ZM328.841 9.09244H328.347V10.9574H328.875C329.479 10.9574 329.787 10.6544 329.787 10.0269C329.787 9.45047 329.463 9.09244 328.841 9.09244ZM330.396 8.87014H331.812V9.09244H330.625V9.90489H331.703V10.1272H330.625V10.9593H331.846V11.1856H330.398V8.87407L330.396 8.87014ZM333.147 8.87014H333.379V10.9554H334.559V11.1816H333.147V8.87014ZM335.756 8.80522L336.767 11.1816H336.513L336.344 10.7764H335.168L334.999 11.1816H334.743L335.756 8.80522ZM335.262 10.5541H336.247L335.754 9.38949L335.262 10.5541ZM338.369 8.80719L339.092 10.6328L339.805 8.80522L340.379 11.1816H340.147L339.753 9.52916L339.09 11.2485L338.417 9.52916L338.008 11.1816H337.776L338.369 8.80719ZM340.736 10.379V8.87014H340.967V10.3455C340.967 10.7351 341.161 11.0085 341.606 11.0085C342.051 11.0085 342.238 10.741 342.238 10.3455V8.87014H342.47V10.379C342.47 10.8806 342.129 11.221 341.6 11.221C340.969 11.221 340.736 10.7547 340.736 10.379ZM343.697 8.8308C343.975 8.82293 344.241 8.93703 344.426 9.13768L344.261 9.26358C344.128 9.12784 343.963 9.05309 343.697 9.05309C343.457 9.05309 343.157 9.15145 343.149 9.40326C343.133 9.96194 344.521 9.71998 344.521 10.5718C344.521 11.0105 344.116 11.2229 343.697 11.2229C343.302 11.2229 343.022 11.0813 342.845 10.8275L343.038 10.6878C343.189 10.8944 343.437 11.0105 343.697 10.9987C344.051 10.9987 344.295 10.8531 344.295 10.5934C344.295 9.95604 342.919 10.1685 342.919 9.43473C342.919 9.08457 343.243 8.83473 343.697 8.83473V8.8308ZM345.058 8.22293C345.157 8.22293 345.238 8.29768 345.24 8.39211C345.242 8.48653 345.163 8.56719 345.066 8.56916C344.97 8.57112 344.887 8.4944 344.885 8.39998C344.883 8.30555 344.958 8.22883 345.054 8.22489C345.054 8.22489 345.058 8.22489 345.06 8.22489L345.058 8.22293ZM344.942 11.1796H345.173V8.86817H344.942V11.1796ZM346.72 8.82883C347.339 8.82883 347.846 9.36784 347.846 10.0229C347.846 10.6229 347.423 11.1226 346.875 11.2092C346.962 11.3646 347.129 11.461 347.31 11.459C347.462 11.459 347.613 11.4275 347.75 11.3665V11.5475C347.607 11.6144 347.452 11.6459 347.294 11.6439C346.92 11.6439 346.726 11.4334 346.626 11.2151C346.052 11.1619 345.594 10.6485 345.594 10.0269C345.594 9.36785 346.102 8.82883 346.72 8.82883ZM345.814 10.0229C345.814 10.558 346.227 11.0026 346.72 11.0026C347.214 11.0026 347.627 10.558 347.627 10.0229C347.627 9.48784 347.214 9.04129 346.72 9.04129C346.227 9.04129 345.814 9.48784 345.814 10.0229ZM348.217 10.377V8.86817H348.449V10.3436C348.449 10.7331 348.642 11.0065 349.087 11.0065C349.532 11.0065 349.726 10.7351 349.726 10.3436V8.86817H349.957V10.377C349.957 10.8787 349.617 11.219 349.087 11.219C348.451 11.219 348.217 10.7528 348.217 10.377ZM350.461 8.86817H351.877V9.09047H350.691V9.90293H351.768V10.1252H350.691V10.9574H351.907V11.1836H350.459V8.87211L350.461 8.86817ZM297.771 1.71145H304.948C307.385 1.71145 311.475 2.53965 311.475 8.08916C311.475 13.1115 307.359 14.1541 307.186 14.1954L306.537 14.3449L306.533 16.678V16.8177C306.533 17.9744 306.533 19.4144 305.792 20.1423C305.506 20.4216 305.111 20.5947 304.593 20.6675C304.738 19.8885 304.738 19.0898 304.736 18.4033V16.5836L304.738 12.9718C307.117 12.7416 309.581 11.3862 309.581 8.1344C309.581 5.74424 308.243 4.59735 307.123 4.05834C306.344 3.69244 305.492 3.49375 304.626 3.47801H299.572V16.6839C299.572 18.0433 299.572 20.9567 301.971 21.9895C301.642 22.1744 301.177 22.2983 300.5 22.2983C298.21 22.2983 297.777 20.8839 297.777 18.2695L297.771 1.71539V1.71145ZM303.925 11.3567L303.048 11.3233V18.3993C303.048 19.0741 303.048 19.8747 302.891 20.5613C301.532 20.1462 301.252 18.8282 301.252 16.6741V5.11473H304.626C304.96 5.11473 307.889 5.19932 307.889 8.1285C307.889 11.0577 304.896 11.3567 303.979 11.3567H303.921M300.494 23.9331C302.382 23.9331 303.395 23.156 303.941 22.3475H303.977C305.258 22.3475 306.269 21.9954 306.98 21.299C308.217 20.0892 308.215 18.1947 308.215 16.8098V15.5783C309.688 15.0019 313.157 13.1115 313.157 8.08522C313.157 0.641288 306.872 0.0629272 304.948 0.0629272H296.087V18.2577C296.087 19.9554 296.087 23.9311 300.498 23.9311",
            fill: "#02016F"
          }
        })
      ]),
      _vm._v(" "),
      _c("g", { attrs: { "clip-path": "url(#clip4_778_1196)" } }, [
        _c("path", {
          attrs: {
            d:
              "M384.05 4.32397C384.425 4.98897 384.779 5.61835 385.149 6.27385C384.559 6.6111 383.986 6.9151 383.439 7.25947C382.761 7.68697 382.464 8.33535 382.558 9.1191C382.648 9.8696 383.076 10.4064 383.792 10.689C384.363 10.9122 384.922 10.8481 385.452 10.5536C385.975 10.2639 386.496 9.96698 387.054 9.65348C387.439 10.3327 387.811 10.9906 388.203 11.6865C388.062 11.7743 387.95 11.8503 387.833 11.9168C385.92 12.9951 384.012 14.0781 382.09 15.1421C381.39 15.5292 380.85 16.0327 380.585 16.8497C380.511 16.7595 380.451 16.7048 380.413 16.636C379.267 14.5958 378.116 12.5557 376.979 10.5109C376.425 9.51098 376.719 8.44697 377.705 7.8841C379.744 6.72035 381.796 5.5756 383.842 4.42372C383.897 4.39285 383.955 4.37147 384.05 4.32635V4.32397Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M430.873 10.9146C432.32 9.62974 434.164 10.1332 435.014 11.069C436.141 12.3111 436.191 14.3014 435.073 15.5649C433.977 16.8046 432.537 16.8782 430.964 15.7715C430.944 15.7881 430.916 15.8024 430.911 15.8237C430.823 16.2101 430.571 16.4032 430.154 16.4032C429.624 16.4032 429.359 16.1444 429.359 15.6266C429.359 13.1756 429.364 10.7222 429.347 8.27124C429.347 7.93161 429.442 7.83899 429.777 7.84374C430.873 7.85324 430.873 7.83899 430.873 8.94811V10.9146ZM434.352 13.368C434.357 12.3159 433.657 11.5986 432.628 11.5986C431.608 11.5986 430.916 12.2969 430.911 13.3324C430.906 14.3987 431.592 15.1017 432.63 15.0994C433.65 15.0994 434.35 14.394 434.352 13.368Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M404.991 10.9716C405.003 10.7698 405.015 10.5869 405.032 10.347C405.466 10.347 405.896 10.3351 406.326 10.3589C406.395 10.3636 406.515 10.5204 406.515 10.6059C406.529 12.4489 406.531 14.2919 406.519 16.1349C406.519 16.2275 406.388 16.3938 406.309 16.3985C405.891 16.4246 405.473 16.4104 405.036 16.4104C405.02 16.18 405.005 15.9853 404.984 15.7003C404.289 16.465 403.456 16.6693 402.541 16.5458C401.829 16.4508 401.249 16.085 400.788 15.5388C399.742 14.299 399.766 12.3444 400.838 11.1545C401.939 9.93139 403.284 9.86489 404.989 10.9693L404.991 10.9716ZM405.01 13.3609C405.01 12.3491 404.284 11.6105 403.288 11.6058C402.281 11.601 401.531 12.3586 401.536 13.3775C401.54 14.3798 402.285 15.1374 403.264 15.1421C404.265 15.1469 405.01 14.3845 405.008 13.3609H405.01Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M446.527 14.0947C446.72 14.3465 446.875 14.6434 447.116 14.8381C447.728 15.3321 448.915 15.2846 449.507 14.7621C449.676 14.6125 449.791 14.603 449.968 14.7146C450.266 14.9046 450.579 15.078 450.918 15.2775C450.491 15.8903 449.941 16.2726 449.244 16.427C447.943 16.7144 446.744 16.5457 445.784 15.5435C444.645 14.3512 444.671 12.2969 445.82 11.0975C446.942 9.92662 448.9 9.78175 450.099 10.8006C451.069 11.6247 451.374 12.6887 451.186 13.9594H446.624L446.527 14.0947ZM449.674 12.7647C449.605 12 448.931 11.4561 448.119 11.487C447.255 11.5202 446.603 12.0641 446.596 12.7647H449.674Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M427.119 13.9712H422.589C422.553 14.5222 423.061 15.0471 423.735 15.1469C424.382 15.2419 425.013 15.2205 425.533 14.7289C425.588 14.6766 425.729 14.6457 425.791 14.679C426.149 14.8666 426.496 15.078 426.868 15.2917C426.328 16.0589 425.605 16.4294 424.731 16.5362C422.992 16.7476 421.485 15.9187 421.029 14.2966C420.504 12.4251 421.626 10.5085 423.427 10.2045C425.76 9.81262 427.508 11.5606 427.119 13.9689V13.9712ZM422.517 12.7742H425.626C425.524 12.0071 424.946 11.5297 424.139 11.5226C423.248 11.5155 422.641 11.9739 422.517 12.7742Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M409.464 10.955C409.994 10.2971 410.675 10.1309 411.436 10.176C412.468 10.2377 413.368 10.9146 413.457 11.9287C413.588 13.4012 413.562 14.8904 413.605 16.3937H412.081C412.069 16.2275 412.053 16.0684 412.05 15.9092C412.041 14.8666 412.062 13.824 412.017 12.7837C411.983 11.9739 411.496 11.5416 410.751 11.563C409.975 11.5844 409.447 12.0736 409.426 12.855C409.399 13.8834 409.414 14.9141 409.411 15.9449C409.411 16.0826 409.411 16.218 409.411 16.3866H407.893C407.883 16.2607 407.866 16.1254 407.866 15.99C407.866 14.2491 407.873 12.5059 407.857 10.765C407.854 10.4254 407.95 10.3042 408.289 10.3422C408.504 10.366 408.724 10.3612 408.941 10.3422C409.263 10.3114 409.469 10.385 409.411 10.765C409.404 10.8054 409.435 10.8529 409.466 10.9597L409.464 10.955Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M420.377 11.7079C419.967 11.9477 419.551 12.1876 419.119 12.4394C418.682 11.8147 418.099 11.5582 417.356 11.6794C416.676 11.791 416.122 12.3491 416.029 13.0284C415.916 13.8596 416.253 14.5697 416.915 14.8927C417.579 15.2157 418.431 15.0922 418.887 14.5555C419.09 14.3156 419.233 14.2966 419.479 14.4652C419.773 14.6647 420.091 14.8239 420.394 14.9996C419.857 16.1705 418.331 16.8022 416.876 16.4816C415.475 16.1729 414.45 14.8286 414.476 13.3347C414.503 11.7839 415.503 10.5322 416.962 10.2211C418.355 9.92423 419.871 10.5726 420.375 11.7079H420.377Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M395.384 9.13338C394.488 9.22601 394.211 9.43738 394.113 10.0098C394.068 10.271 394.154 10.3589 394.407 10.3494C394.71 10.3375 395.016 10.347 395.377 10.347C395.377 10.7816 395.386 11.1854 395.367 11.5844C395.365 11.6509 395.262 11.7316 395.186 11.772C395.124 11.8029 395.035 11.7839 394.959 11.7839C394.373 11.7918 394.08 12.0934 394.08 12.6888C394.08 13.7694 394.08 14.8476 394.08 15.9283C394.08 16.0779 394.066 16.2251 394.059 16.3914H392.571C392.571 16.2465 392.571 16.1111 392.571 15.9781C392.571 14.7194 392.561 13.463 392.576 12.2066C392.578 11.9074 392.511 11.7364 392.179 11.7863C391.783 11.848 391.651 11.6746 391.694 11.2946C391.725 11.0191 391.616 10.6676 391.749 10.48C391.864 10.3209 392.239 10.3446 392.537 10.2805C392.568 10.0573 392.604 9.79601 392.645 9.53951C392.805 8.55388 393.516 7.86038 394.515 7.75826C395.508 7.65851 395.377 7.54926 395.384 8.51351C395.384 8.71301 395.384 8.91488 395.384 9.13338Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M452.623 10.2924C452.623 9.92662 452.609 9.61075 452.63 9.29725C452.638 9.19512 452.714 9.04075 452.795 9.01225C453.213 8.86262 453.643 8.74862 454.144 8.599C454.144 9.07637 454.154 9.5015 454.142 9.92662C454.135 10.2069 454.242 10.3304 454.527 10.2852C454.55 10.2805 454.577 10.2852 454.603 10.2852C454.904 10.3066 455.202 10.3304 455.503 10.3517C455.518 10.7674 455.541 11.183 455.532 11.5986C455.532 11.6532 455.374 11.7411 455.286 11.7482C455.007 11.7672 454.722 11.7649 454.443 11.753C454.233 11.7435 454.137 11.8219 454.14 12.0356C454.149 12.8099 454.137 13.5865 454.161 14.3607C454.176 14.8025 454.39 14.9806 454.851 15.002C455.066 15.0115 455.281 15.002 455.549 15.002C455.549 15.42 455.563 15.7976 455.537 16.1752C455.532 16.256 455.379 16.3937 455.296 16.3937C454.787 16.3795 454.266 16.3961 453.777 16.2821C453.001 16.1016 452.652 15.4984 452.626 14.4344C452.607 13.6981 452.621 12.9595 452.619 12.2232C452.619 12.0855 452.619 11.9501 452.619 11.7672H451.551C451.551 11.3089 451.539 10.8932 451.563 10.48C451.568 10.4111 451.728 10.309 451.826 10.2995C452.064 10.2734 452.31 10.29 452.621 10.29L452.623 10.2924Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M439.704 11.8955C439.704 10.575 439.716 9.25447 439.697 7.93397C439.692 7.57297 439.816 7.4851 440.155 7.48747C441.213 7.4946 441.213 7.48272 441.213 8.54435C441.213 11.0072 441.206 13.4725 441.223 15.9353C441.225 16.2916 441.115 16.3866 440.771 16.3842C439.709 16.3747 439.709 16.3866 439.709 15.3273V11.8978H439.704V11.8955Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M444.06 11.9193C444.06 13.2801 444.053 14.641 444.064 16.0019C444.067 16.2821 443.983 16.3748 443.697 16.3795C442.558 16.4009 442.558 16.408 442.558 15.287C442.558 12.8313 442.562 10.3779 442.548 7.92215C442.548 7.58965 442.634 7.48277 442.976 7.48515C444.057 7.4899 444.057 7.47802 444.057 8.56102V11.9193H444.06Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M385.7 18.3341C385.058 18.6833 384.473 19.0466 383.85 19.3316C383.014 19.714 382.023 19.3696 381.547 18.5883C381.065 17.7974 381.213 16.7239 381.958 16.1848C382.541 15.762 383.198 15.439 383.85 15.0566C384.473 16.161 385.072 17.2203 385.703 18.3341H385.7Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M397.834 10.3446V11.2305C398.271 10.5798 398.854 10.2425 399.649 10.2188V11.8646C399.382 11.9074 399.112 11.9216 398.863 11.9953C398.183 12.1995 397.834 12.6745 397.827 13.3799C397.82 14.3702 397.827 15.3606 397.827 16.3819H396.339C396.33 16.256 396.31 16.1325 396.31 16.009C396.306 14.2681 396.31 12.5249 396.294 10.784C396.291 10.4372 396.389 10.3042 396.747 10.3351C397.087 10.366 397.433 10.3422 397.836 10.3422L397.834 10.3446Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M438.369 13.3419C438.369 14.2301 438.357 15.1207 438.376 16.009C438.383 16.3011 438.281 16.3937 438.004 16.3747C437.748 16.3581 437.493 16.3605 437.237 16.3747C436.965 16.3914 436.848 16.3035 436.848 16.0114C436.855 14.2325 436.848 12.4536 436.841 10.6747C436.841 10.4206 436.922 10.2971 437.194 10.3114C437.473 10.3256 437.758 10.328 438.037 10.3114C438.316 10.2947 438.379 10.4182 438.374 10.6724C438.362 11.5606 438.369 12.4512 438.369 13.3395V13.3419Z",
            fill: "#02016F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M438.529 8.55387C438.536 9.09062 438.137 9.48962 437.595 9.48962C437.079 9.48962 436.666 9.10013 436.65 8.59425C436.635 8.09313 437.072 7.62762 437.574 7.61337C438.078 7.59912 438.522 8.0385 438.529 8.55387Z",
            fill: "#02016F"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_778_1196" } }, [
          _c("rect", { attrs: { width: "50", height: "24", fill: "white" } })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip1_778_1196" } }, [
          _c("rect", {
            attrs: {
              width: "68",
              height: "15.1592",
              fill: "white",
              transform: "translate(74 4.42041)"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip2_778_1196" } }, [
          _c("rect", {
            attrs: {
              width: "106",
              height: "7.06667",
              fill: "white",
              transform: "translate(166 8.46667)"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip3_778_1196" } }, [
          _c("rect", {
            attrs: {
              width: "56",
              height: "24",
              fill: "white",
              transform: "translate(296)"
            }
          })
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip4_778_1196" } }, [
          _c("rect", {
            attrs: {
              width: "80",
              height: "16",
              fill: "white",
              transform: "translate(376 4)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }